var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M0 0L0 500L500 500L500 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M266 50L268 52L266 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M267 50L267 51C279.591 51 307.939 44.7625 308 62L264 61L267 52L267 51C260.987 54.5127 263 63.9003 263 70L263 109C263 115.967 261.918 123.596 265 130L228 130L228 117C223.246 117 214.403 118.698 210.318 115.972C206.42 113.371 208 105.011 208 101L208 67C208 63.5376 209.135 57.4229 206.397 54.7423C202.115 50.5507 188.608 53 183 53C177.245 53 164.952 50.699 160.318 54.6034C156.108 58.1506 158 68.0791 158 73C158 90.3857 154.078 113.349 159 130C154.769 130 129.749 127.516 131.752 134.791C132.895 138.947 139.831 137.999 143 138L177 138L285 138L314 138C317.455 138 322.657 138.88 325.677 136.821C330.845 133.299 324.213 130.245 321 130L321 117L309 117L309 69C309 64.2895 310.768 55.1121 306.682 51.7423C303.653 49.2438 298.64 50.0002 295 50L267 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M305 50L306 51L305 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M306 50L307 51L306 50M264 51L265 52L264 51M268 51L268 52L304 52C294.44 47.9886 278.387 51 268 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M304 51L305 52L304 51M307 51L308 52L307 51M265 52L266 53L265 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M265 61L308 61C307.841 47.5152 289.906 52 280 52C276.467 52 269.546 50.6999 266.603 53.0278C264.435 54.7435 265.009 58.5762 265 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M306 52L307 53L306 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M308 52L309 53L308 52M160 53L161 54L160 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M205 53L206 54L205 53M263 53L264 54L263 53M307 53L308 54L307 53M159 54L160 55L159 54M161 54L162 55L161 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M162 54L162 55L204 55C193.012 50.3893 173.957 54 162 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M204 54L205 55L204 54M264 54L265 55L264 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M309 54L310 55L309 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15a36b",
      stroke: "none"
    },
    d: "M433 54.4676C405.417 59.6714 412.134 103.852 440 99.5208C470.489 94.7824 463.003 48.8072 433 54.4676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M158 55L159 56L158 55M160 55L161 56L160 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M205 130L207 76L205.972 56.6034L197 55L171 55L161.028 56.6034L160 72L160 113L161.603 128.972L174 130L205 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M264 55L264 61L265 61L264 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M309 55L309 117L310 117L310 75L309 55M159 56L160 57L159 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M208 56L209 57L208 56M262 56L262 125L263 125L263 78L262 56M159 57L159 128L160 128L160 79L159 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M208 57L208 116L209 116L209 76L208 57M369 59L369 60L372 60L369 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M337 80L338 80C343.406 72.3268 349.404 67.246 359 69C367.67 56.9817 383.727 59.6152 388 74C390.087 66.3624 379.732 59.6994 373 59.5903C366.153 59.4793 363.128 64.2091 357.424 66.5517C348.633 70.1624 341.176 69.2275 337 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M374.667 59.3333L375.333 59.6667L374.667 59.3333M366 60L367 61L366 60M378 60L379 61L378 60M275 61L275 62L298 62L275 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M298 61L298 62L308 62L298 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M364 61L365 62L364 61M367 61L368 62L367 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M359 70C343.779 63.6779 339.489 79.2551 337.178 90C336.128 94.881 331.382 98.0714 330.463 103C329.602 107.617 333.569 110.688 334.131 115C335.191 123.128 332.642 132.118 337.042 139.851C343.485 151.172 358.398 133.453 360 127C346.592 122.439 346.172 107.693 344 96L341 97L356 76C357.065 89.4944 377.814 89.6626 385.562 97.3572C390.001 101.765 384.729 107.199 384.133 112C382.978 121.303 390.175 131.924 398.005 136.647C403.544 139.989 412.407 141.699 413.756 132.996C415.178 123.821 407.417 115.605 403.988 108C401.989 103.567 403.973 98.4894 402.258 94C400.083 88.306 394.012 84.9654 390.702 80C387.869 75.7503 387.559 70.2914 384.2 66.3287C376.889 57.7048 363.593 60.2387 359 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M377 61L378 62L377 61M380 61L381 62L380 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M179 62L180 63L179 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M180 62L180 63L187 63L187 62L180 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M181 62L181 63L185 63L181 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M264 64L268 63L264 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M362 62L363 63L362 62M365 62L366 63L365 62M379 62L380 63L379 62M382 62L383 63L382 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M177 63L179 65L177 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M178 63L178 64L181 64L178 63M185 63L185 64C196.317 67.8497 198.805 84.5111 185 87.3341C170.794 90.2391 168.794 71.8408 178 65C164.707 64.7152 170.287 88.1607 183 88.7215C198.726 89.4151 200.593 64.7378 185 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M189 63L190 64L189 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M265 63L266 66L269 63L265 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M269 63L267 66L269 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M272 63L274 66L275 66L277 63L272 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M278 63L279 64L278 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M279 63L278 70L279 70C280.857 67.0031 281.317 65.7538 279 63M282.667 63.3333L283.333 63.6667L282.667 63.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M284 63L283 65L284 63M286 63L287 64L286 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M287 63L288 64L287 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M289 63L289 64L293 64L289 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M296 63L297 64L296 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M297 63L298 66L300 66L301 63L297 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M301 63L302 64L301 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M304 63L308 67L308 63L304 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M361 63L362 64L361 63M363 63L364 64L363 63M381 63L382 64L381 63M383 63L384 64L383 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M175 64L176 65L175 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M179.004 64.7423C165.13 70.0938 174.014 91.9656 187.985 86.142C201.571 80.4783 192.667 59.472 179.004 64.7423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M187 64L188 65L187 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M269 64L268 66L269 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M270 64L268 67L270 64M282 64L283 65L282 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M284 64L275 68L275 75L273 69L271 71L270 71L268 69L266 76C270.488 74.1808 271.819 75.5119 270 80L273 77L274 77L277 80C275.867 75.8957 278.659 72.9165 280 78L283 77C283.947 80.7138 283.993 82.9477 280 84L278 90L277 90L274 87C274.75 91.6444 273.381 92.7744 269 91C271.096 95.885 269.453 97.6963 267 102L270 101L270 108C273.727 107.446 274.932 108.417 276 112L279 112L281 107L282 107L284 109C284.233 103.688 288.125 104.759 286 110L289 107L290 107L292 109L294 102L295 102L295 109L301 111L303 111L304 108L301 109L299 106L299 105L301 103L295 102L295 101L301 98L306 94L307 88C302.777 88.6325 301.91 86.9501 303 83L304 83L307 86L307 79C302.777 79.6325 301.91 77.95 303 74L304 74L307 77L306 70L304 72L303 72L296 64L296 71L295 71L292 68L290 75L284 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M285 64L284 66L285 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M284 66L284 67L288 69L288 64L284 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M293 64L294 65L293 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M294 64L292 66L292 67L294 70L298 68L298 67L294 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M295 64L296 65L295 64M297 64L298 65L297 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M360 64L361 65L360 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M362 64L363 65L362 64M382 64L383 65L382 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M384 64L385 65L384 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M430 69C445.896 60.5865 435.029 76.8492 435 85C436.817 80.8371 442.46 73.3627 442.083 69.044C441.416 61.4032 432.327 64.3855 430 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M174 65L175 66L174 65M176 65L177 66L176 65M181 65L181 66L185 66L181 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M185 65L186 66L185 65M189 65L190 66L189 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M269 70L273 66L272 65L269 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M281 65L282 66L281 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M296 65L297 66L296 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M302 65C301.501 68.3142 302.059 69.3799 305 71L302 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M303 65L304 66L303 65M359 65L360 66L359 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M361 65L362 66L361 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M385 65L386 66L385 65M173 66L174 67L173 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M175 66L176 67L175 66M178 66L179 67L178 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M174 73L175 73C179.571 66.7221 192.464 64.7095 191.663 75.9992C190.904 86.6904 179.396 84.038 175 78C173.683 87.7618 190.369 86.3265 192.562 77.9962C195.754 65.8737 177.964 61.6227 174 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M187 66L188 67L187 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M264 66L264 68L266 68L264 66M289 66L290 67L289 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M299 66L300 67L299 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M352 66L352 67L356 67L352 66M358 66L359 67L358 66M360 66L361 67L360 66M384 66L385 67L384 66M386 66L387 67L386 66M172 67L173 68L172 67M174 67L175 68L174 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M179 67L180 68L179 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M180.044 67.7462C170.603 71.4528 176.05 87.0291 185.985 83.2538C196.502 79.2574 190.058 63.8145 180.044 67.7462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M186 67L187 68L186 67M189 67L190 68L189 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M275 67L276 68L275 67M282 67L283 68L282 67M292 67L293 68L292 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M300 67L301 68L300 67M307 67L308 68L307 67M349 67L350 68L349 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M357 67L358 68L357 67M359 67L360 68L359 67M385 67L386 68L385 67M173 68L174 69L173 68M188 68L189 69L188 68M190 68L191 69L190 68M194 68L195 69L194 68M264 68L265 69L264 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M268 68L269 69L268 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M272 68L273 69L272 68M274 68L275 69L274 68M276 68L277 69L276 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M281 74C283.941 72.3799 284.499 71.3142 284 68C281.059 69.6201 280.501 70.6858 281 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M285 68L286 69L285 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M290 68C288.414 72.0301 289.97 73.5865 294 72L294 71L290 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M291 68L292 69L291 68M293 68L294 69L293 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M297 68L298 69L297 68M300 68L301 69L300 68M347 68L348 69L347 68M350 68L351 69L350 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M351 68L352 69L351 68M356 68L357 69L356 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M387 68L388 69L387 68M171 69L172 70L171 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M189 69L190 70L189 69M191 69L192 70L191 69M193 69L194 70L193 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M266 69L265 75L269 72L269 71L266 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M267 69L268 70L267 69M271 69L272 70L271 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M273 69L273 75L277 72L273 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M275 69L276 70L275 69M277 69L278 70L277 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M286.667 69.3333L287.333 69.6667L286.667 69.3333M292 69L293 70L292 69M296 69L297 70L296 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M298 69L297 71L298 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M299 69L299 76C301.459 73.361 301.278 71.7721 299 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M301 69L302 70L301 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M305 69L306 70L305 69M345 69L346 70L345 69M348 69L349 70L348 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M357 69L358 70L357 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M358 69L359 70L358 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M386 69L387 70L386 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M172 70L173 71L172 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M174 70L175 71L174 70M190 70L191 71L190 70M195 70L196 71L195 70M270 70L271 71L270 70M276 70L277 71L276 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M285 70L286 71L285 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M295 70L296 71L295 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M300 70L301 71L300 70M302 70L303 71L302 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M306 70L305 72L306 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M307 70L308 71L307 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M344 70L345 71L344 70M346 70L347 71L346 70M388 70L389 71L388 70M170 71L171 72L170 71M175 71L176 72L175 71M192 71L193 72L192 71M194 71L195 72L194 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M264 71L264 74L265 74L264 71M271 71L272 72L271 71M279 71L280 72L279 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M285 71L284 73L285 71M296 71L298 74L296 71M301 71L302 72L301 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M303 71L304 72L303 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M306 71L308 76L308 71L306 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M387 71L388 72L387 71M171.333 72.6667L171.667 73.3333L171.333 72.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M173 72L174 73L173 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M191 72L192 73L191 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M196 72L197 73L196 72M268 72L269 73L268 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M271 72L272 73L271 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M285 72L283 75L285 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M286 72L284 75L286 72M293 72L294 73L293 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M302 72L303 73L302 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M387 72L388 73L387 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M173 73L173 78C175.034 76.2315 175.034 74.7685 173 73M196 73L196 78L197 78L196 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M267 73L268 74L267 73M269.667 73.3333L270.333 73.6667L269.667 73.3333M272 73L273 74L272 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M275 73L276 74L275 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M277 73C275.907 76.1906 276.047 77.2856 279 79L279 73L277 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M283 73L284 74L283 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M286 80C288.714 77.612 289.151 76.4342 288 73C284.633 74.9051 284.566 76.515 286 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M292 73L293 74L292 73M294 73L295 74L294 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M295 73L292 76L292 77L295 80L296 80L295 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M296 73L299 76L296 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M389 73L388 75L390 75L389 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M171 74L171 77L172 77L171 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M173 74L173 77L174 77L173 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M193 74L193 77L194 77L193 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M264 74L265 75L264 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M266 74L267 75L266 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M268 74L266 77L268 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M267 78L268 79L272 75L271 74L267 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M271 74L272 75L271 74M274 74L275 75L274 74M281 74L282 75L281 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M282 74L283 75L282 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M290 74L291 75L290 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M291 74L292 75L291 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M293 74L294 75L293 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M296 74L297 75L296 74M298 74L299 75L298 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M303 74C301.724 77.2159 301.954 78.2788 305 80L306 79L303 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M265 75L266 76L265 75M272.333 75.6667L272.667 76.3333L272.333 75.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M275 75L276 76L275 75M280.333 75.6667L280.667 76.3333L280.333 75.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M283 75L284 76L283 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M289 75L290 76L289 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M292 75L293 76L292 75M297 75L298 76L297 75M300 75L301 76L300 75M306 75L307 76L306 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M388 75L389 76L388 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M389.333 75.6667L389.667 76.3333L389.333 75.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M283 76L284 77L283 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M298 76L297 79L300 79L298 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M305 76L306 77L305 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M307 76L308 77L307 76M338 76L339 77L338 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M354 77L354 78L357 78L354 77M390 76L391 77L390 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M171.333 77.6667L171.667 78.3333L171.333 77.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M271 77L272 78L271 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M273 77L274 78L273 77M275 77L276 78L275 77M280 78L280 79L284 79L280 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M284 77L285 78L284 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M290 77L291 78L290 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M306 77L307 78L306 77M337 77L338 78L337 77M339 77L340 78L339 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M355 77C353.048 84.2082 347.023 90.6316 341 95L341 96L344 95L349.98 118.996L361 134L362 134L361 127L365 127L365 126C351.536 125.675 342.375 106.31 346.383 94.0008C347.936 89.2319 352.047 86.7285 355 83L356 83C358.725 85.5561 361.698 85.4185 364.83 87.1744C370.474 90.3384 374.979 97.6062 382 97L382 96L378 97L355 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M389.667 77.3333L390.333 77.6667L389.667 77.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M173 78L174 79L173 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M191 78L192 79L191 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M196 78L197 79L196 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M265 78L265 84C267.145 81.5729 267.101 80.4703 265 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M267 78L269 80L267 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M270 78L271 79L270 78M272 78L273 79L272 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M273 78L270 81L270 82C274.118 83.621 276.187 81.4241 273 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M274 78L275 79L274 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M276 78L277 79L276 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M281.313 79.341C279.173 80.2278 280.548 83.5453 282.687 82.659C284.827 81.7722 283.452 78.4547 281.313 79.341M290 85C293.367 83.0949 293.434 81.485 292 78C288.668 79.899 288.762 81.4973 290 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M298 78L294 80C292.821 83.8773 290.338 83.3582 287 82C289.475 88.2233 284.596 94.6441 278 92L281 96L281 97L278 100L277 100L274 97L274 104L280 104L281 97L282 97L284 99L287 92L290 96L290 97L287 100L290 97L291 97L293 99L291 97L291 96L294 93L287 92L287 91L294 90L294 83L299 86L296 82L296 81L298 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M301 78L302 79L301 78M306 78L307 79L306 78M338 78L339 79L338 78M354 78L355 79L354 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M389 78L390 79L389 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M390 78L403 95L404 95L390 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M170 79L171 80L170 79M175 79L176 80L175 79M192 79L193 80L192 79M194 79L195 80L194 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M264 79L264 84L265 84L264 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M267 79L268 80L267 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M269 79L270 80L269 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M271 79L272 80L271 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M275 79L276 80L275 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M277 79L278 80L277 79M294 79L295 80L294 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M296 79L297 80L296 79M298 79L297 81L298 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M301 85L301 79C297.528 80.9752 297.528 83.0247 301 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M302 79L303 80L302 79M305 79L306 80L305 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M307 79L305 82L305 83L308 85L307 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M336 79L337 80L336 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M355.333 79.6667L355.667 80.3333L355.333 79.6667M391 79L392 80L391 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M172 80L173 81L172 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M174 80L175 81L174 80M190 80L191 81L190 80M195 80L196 81L195 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M267 80L268 81L267 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M270 80L271 81L270 80M276 80L277 81L276 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M293 80L294 81L293 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M295 80L296 81L295 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M301 80L302 81L301 80M303 80L304 81L303 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M304 80L305 81L304 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M306 80L307 81L306 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M336.667 80.3333L337.333 80.6667L336.667 80.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M390 80L391 81L390 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M171 81L172 82L171 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M189 81L190 82L189 81M191 81L192 82L191 81M193 81L194 82L193 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M287 81L288 82L287 81M294 81L295 82L294 81M296 81L297 82L296 81M302 81L303 82L302 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M305 81L306 82L305 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M336 81C335.999 90.2752 328.931 95.9162 328.558 104C328.352 108.465 332.464 111.615 332.765 116C333.201 122.342 328.772 128.109 336 132C333.924 137.681 334.71 142.19 341 144L341 143C335.488 140.257 335.924 136.454 337 131C330.458 127.467 334.081 121.96 333.906 116C333.771 111.424 329.2 107.495 330.233 103C332.107 94.8448 339.977 90.4777 336 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M337 81L338 82L337 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M173 82L174 83L173 82M188 82L189 83L188 82M190 82L191 83L190 82M194 82L195 83L194 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M277 82C274.837 85.5401 274.913 87.1669 278 90C279.282 86.5468 279.504 84.7921 277 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M286 82L288 84L286 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M288 82L289 83L288 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M302 82L303 83L302 82M335 82L335 87L336 87L335 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M356 82L357 83L356 82M393 82L394 83L393 82M172 83L173 84L172 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M174 83L175 84L174 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M179 83L180 84L179 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M186 83L187 84L186 83M189 83L190 84L189 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M268 89L270 83C267.047 84.7144 266.907 85.8094 268 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M280 83L281 84L280 83M283 83L284 84L283 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M285 83L286 90L287 90L290 87L285 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M289 83L290 84L289 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M294 83L293 85L294 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M295 83L292 86L292 87L295 90L296 90C297.51 86.7755 297.521 85.5529 295 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M301 83L302 84L301 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M303 83L301 86L303 83M353 83L354 84L353 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M354 84L354 85L357 85L354 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M357 83L358 84L357 83M394 83L395 84L394 83M173 84L174 85L173 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M175 84L176 85L175 84M178 84L179 85L178 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M187 84L188 85L187 84M272 84L273 85L272 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M279 84L280 85L279 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M281.667 84.3333L282.333 84.6667L281.667 84.3333M288 84L289 85L288 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M303 90L305 84C302.047 85.7144 301.907 86.8094 303 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M352 84L353 85L352 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M377 116L362 128L362 134L385 130L380 109C383.222 107.232 388.13 102.723 384.817 98.6212C383.174 96.5869 379.517 97.7309 377.285 96.5555C369.709 92.5659 360.788 80.1106 351.21 87.0741C340.933 94.5458 347.269 123.253 360.004 125.566C366.96 126.829 372.605 120.358 377 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M359 84L360 85L359 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M360 84L360 85L364 85L360 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M174 85L175 86L174 85M176 85L177 86L176 85M181 85L181 86L185 86L181 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M185 85L186 86L185 85M189 85L190 86L189 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M271 85L272 86L271 85M280 85L281 86L280 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M283 85L284 86L283 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M289 85L290 86L289 85M299 85L300 86L299 85M307 85L308 86L307 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M350 85L351 86L350 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M351 85L352 86L351 85M353 85L354 86L353 85M358 85L359 86L358 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M175 86L176 87L175 86M178 86L179 87L178 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M188 86L189 87L188 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M266 86L267 87L266 86M274 86L275 87L274 86M280 86L281 87L280 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M298 86L299 87L298 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M306.333 86.6667L306.667 87.3333L306.333 86.6667M348 86L349 87L348 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M352 86L353 87L352 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M363.667 86.3333L364.333 86.6667L363.667 86.3333M398 86L399 87L398 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M177 87L178 88L177 87M181 87L181 88L186 88L181 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M189 87L190 88L189 87M264 87L264 93L265 93L264 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M265 87L266 88L265 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M272 87L272 94C275.822 91.8127 275.088 89.6604 272 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M273 87L274 88L273 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M279 87L280 88L279 87M281 87L282 88L281 87M301 87L302 88L301 87M337 87L337 91L338 91L337 87M347 87L348 88L347 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M349 87L350 88L349 87M366 87L367 88L366 87M397 87L398 88L397 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M399 87L400 88L399 87M179 88L180 89L179 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M180 88L181 89L180 88M186 88L187 89L186 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M265 88L265 92L266 92L265 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M278 88L279 89L278 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M280 88L278 91L280 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M281 95L282 95L283 88C279.565 89.9154 279.378 91.5086 281 95M290 95L291 95L294 92L294 91L292 88C288.565 89.9154 288.378 91.5086 290 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M293 88L294 89L293 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M299 88L299 95L300 95C301.51 91.7755 301.521 90.5529 299 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M300 88L301 89L300 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M305 88L306 89L305 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M307 88L305 91L307 88M398 88L399 89L398 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M400 88L401 89L400 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M434 89L434 90L437 91L437 88L434 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M285 89L286 90L285 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M292 89L293 90L292 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M294 89L295 90L294 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M304 89L305 90L304 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M307 89L305 91L305 92L308 94L307 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M348 89L349 90L348 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M369 89L370 90L369 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M399 89L400 90L399 89M401 89L402 90L401 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M269 90L270 91L269 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M284 90L285 91L284 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M293 90L294 91L293 90M346 90L347 91L346 90M368 90L369 91L368 90M400 90L401 91L400 90M268 91L271 94L268 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M270 91L271 92L270 91M278 91L279 92L278 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M287 91L288 92L287 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M296 91L297 92L296 91M302 91L303 92L302 91M335 91L336 92L335 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M347 91L348 92L347 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M361 91L361 92L364 92L361 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M364 91L362 92L362 93L364 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M365 91L366 92L365 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M369 91L370 92L369 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M371 91L372 92L371 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M401 91L402 92L401 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M267 92C266.386 96.1841 268.081 97.5385 272 96L267 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M277 92L279 94L277 92M284 92L285 93L284 92M286 92L288 94L286 92M293 92L294 93L293 92M305 92L306 93L305 92M336 92L337 93L336 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M361 92L362 93L361 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M365 92L365 93L370 98L371 98L365 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M367 92L368 93L367 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M370 92L371 93L370 92M375 92L376 93L375 92M403 92L404 93L403 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M274 95L274 96L276 99C280.323 96.5407 278.608 93.1862 274 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M283 93L284 94L283 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M285 93L285 100L287 100C288.238 96.4973 288.332 94.899 285 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M292 93L293 94L292 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M294 93L294 100C297.088 97.3396 297.822 95.1873 294 93M303 93L302 99C305.178 97.1932 305.502 95.6874 303 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M304 93L305 94L304 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M306 93L307 94L306 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M334 93L335 94L334 93M351 93L351 94L355 94L355 93L351 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M353 93L354 94L353 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M366 93L367 94L366 93M368 93L369 94L368 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M372.667 93.3333L373.333 93.6667L372.667 93.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M374 93L375 94L374 93M376 93L377 94L376 93M402 93L403 94L402 93M265 94L266 95L265 94M282 94L283 95L282 94M291 94L292 95L291 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M293 94L294 95L293 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M298 94L299 95L298 94M305 94L306 95L305 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M307 94L308 95L307 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M335 94L336 95L335 94M342 94L343 95L342 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M345.333 94.6667L345.667 95.3333L345.333 94.6667M349 94L348 96L349 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M348 98L349 98L353 95L348 98M354 94L355 95L354 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M367 94L368 95L367 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M369 94L370 95L369 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M375 94L376 95L375 94M404 94L405 95L404 94M283 95L284 96L283 95M292 95L293 96L292 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M343 95L344 96L343 95M350 95L351 96L350 95M368 95L369 96L368 95M377 95L378 96L377 95M381 95L381 96L385 96L385 95L381 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M383 95L384 96L383 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M403 95L403 97L405 95L403 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M264 96L264 102L265 102L264 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M271 96L272 97L271 96M274 96L275 97L274 96M280 96L281 97L280 96M289 96L290 97L289 96M291 96L292 97L291 96M300 96L301 97L300 96M332 96L333 97L332 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M341 96L342 97L341 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M345 96L346 97L345 96M349 96L350 97L349 96M370 96L371 97L370 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M376 96L377 97L376 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M378.667 96.3333L379.333 96.6667L378.667 96.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M384 96C386.447 101.814 385.745 105.847 380 109L382 116L383 116C383.198 109.768 390.874 100.456 384 96M404 96C403.789 106.222 405.355 108.997 410 118L411 118L404.947 107L404 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M265 97L265 103L266 103L265 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M270 97L271 98L270 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M270 101L271 101L274 98L270 101M275 97L276 98L275 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M279 97L280 98L279 97M281 97L284 100L281 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M283 97L284 98L283 97M288 97L289 98L288 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M290 97L287 101L290 98L291 98L293 100L290 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M292 97L293 98L292 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M299 97L301 99L299 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M307 97L304 100L304 101L307 103L307 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M331 97L332 98L331 97M344 97L345 98L344 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M347.333 97.6667L347.667 98.3333L347.333 97.6667M369 97L370 98L369 97M377 97L378 98L377 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M380 97L381 98L380 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M403 97L403 101L404 101L403 97M181 98L182 99L181 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M182.667 98.3333L183.333 98.6667L182.667 98.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M184.667 98.3333L185.333 98.6667L184.667 98.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M268.667 98.3333L269.333 98.6667L268.667 98.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M272 98L272 103L276 101L272 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M274 98L275 99L274 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M278 98L279 99L278 98M280 98L278 101L280 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M281 98C279.724 101.216 279.954 102.279 283 104L281 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M284 98L285 99L284 98M287 98L288 99L287 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M290 98L287 101L287 102C291.118 103.621 293.187 101.424 290 98M298 104L299 104L302 101C298.576 97.8129 296.379 99.882 298 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M330 98L331 99L330 98M332 98L333 99L332 98M344 98L345 99L344 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M348 98L349 99L348 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M362 98L362 102L364 102L364 98L362 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M370 98L371 99L370 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M378 98L379 99L378 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M379 98L380 99L379 98M385 98L386 99L385 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M178 99L180 101L178 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M179 99L179 100L187 100L179 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M187.333 99.6667L187.667 100.333L187.333 99.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M188 99L189 100L188 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M277 99L278 100L277 99M295 99L296 100L295 99M331 99L332 100L331 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M346.333 99.6667L346.667 100.333L346.333 99.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M351.667 99.3333L352.333 99.6667L351.667 99.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M361.333 99.6667L361.667 100.333L361.333 99.6667M364.333 99.6667L364.667 100.333L364.333 99.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M383 99L384 100L383 99M387 99L387 103L388 103L387 99M176 100L177 101L176 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M179 124L179 123C169.965 116.564 169.006 107.058 179 101C166.365 99.3105 169.216 120.644 179 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M180.001 100.657C166.307 104.803 171.629 127.017 186 123.157C200.832 119.173 194.555 96.2498 180.001 100.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M186 100L187 101L186 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M188 100L188 101C200.067 109.71 194.102 123.668 180 124L180 125C194.467 124.871 203.538 107.312 188 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M190 100L191 101L190 100M267 100L268 101L267 100M350 100L351 101L350 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M351 100L351 103L353 103L353 100L351 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M355 100L356 103L357 103L355 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M356 100L357 101L356 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M381 100L382 101L381 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M379 105L380 105C380.653 103.04 381 102.446 381 105L382 105L384 101C380.954 100.556 380.026 102.298 379 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M177 101L178 102L177 101M183 101L184 102L183 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M189 101L190 102L189 101M191 101L192 102L191 101M267 102L267 103L271 103L267 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M275 101L276 102L275 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M278 101L279 102L278 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M284 101L285 102L284 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M293 101L294 102L293 101M295 101L296 102L295 101M304 101L305 102L304 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M328 101L329 102L328 101M330 101L331 102L330 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M346.333 101.667L346.667 102.333L346.333 101.667M350 101L351 102L350 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M353 101L354 102L353 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M355 101L355 108L356 108L355 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M382 101L382 104L383 104L382 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M403.333 101.667L403.667 102.333L403.333 101.667M179 102L181 104L179 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M180 102L180 103L192 108C189.454 102.906 185.382 102.115 180 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M186 102L187 103L186 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M187 102L188 103L187 102M190 102L191 103L190 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M192 102L193 103L192 102M264 102L265 103L264 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M268 102L268 107L272 105L268 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M274 102L275 103L274 102M276.667 102.333L277.333 102.667L276.667 102.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M279 102L280 103L279 102M287 102L288 103L287 102M292 102L293 103L292 102M294 102L295 103L294 102M296 102L297 103L296 102M300 102L301 103L300 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M302 102L301 108C304.178 106.193 304.502 104.687 302 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M303 102L304 103L303 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M304 102L306 104L304 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M305 102L306 103L305 102M307 102L308 103L307 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M328 102L329 103L328 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M350 102L351 103L350 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M379 102L380 103L379 102M174 103L175 104L174 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M177 103L178 104L177 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M193 109L192 109C190.878 129.492 164.825 115.46 180 104C163.539 103.646 183.207 136.269 191.991 115.958C192.951 113.738 192.944 111.367 193 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M181 103L181 104L185 104L181 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M185 103L186 104L185 103M193 103L194 104L193 103M273 103L274 104L273 103M275 103L274 106L275 106L275 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M276 103L275 104L279 108L280 107L276 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M278 103L279 104L278 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M280 103L281 104L280 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M285 103L285 109L286 109L285 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M286 103L287 104L286 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M288 103L289 104L288 103M291 103L292 104L291 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M293 103L291 106L293 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M294 103L291 106L291 107L293 109L294 109L297 106L297 105L294 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M295 103L296 104L295 103M297 103L298 104L297 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M299 103L300 104L299 103M304 103L305 104L304 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M306 103L307 104L306 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M329 103L329 106L330 106L329 103M345.333 103.667L345.667 104.333L345.333 103.667M351 103L352 104L351 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M352 103L353 104L352 103M354 103L355 104L354 103M380 103L381 104L380 103M387 103L388 104L387 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M404 103L405 104L404 103M176 104L177 105L176 104M178 104L179 105L178 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M179.059 105.028C169.692 110.14 178.642 124.245 187.786 118.821C196.849 113.445 188.051 100.119 179.059 105.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M187 104L188 105L187 104M192 104L193 105L192 104M194 104L195 105L194 104M266 104L267 105L266 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M279 104L280 105L279 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M281 104L282 105L281 104M287 104L288 105L287 104M289 104L290 105L289 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M290 104L291 105L290 104M296 104L297 105L296 104M305 104L306 105L305 104M355 104L356 105L355 104M382 104L383 105L382 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M385 104L386 105L385 104M404 104L404 107L405 107L404 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M171 105L172 106L171 105M175 105L176 106L175 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M177 105L178 106L177 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M193 105L194 106L193 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M271 105L272 106L271 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M288 105L289 106L288 105M299 105L300 106L299 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M345.333 105.667L345.667 106.333L345.333 105.667M353 105L354 106L353 105M381 105L382 106L381 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M386 105L387 106L386 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M436.333 105.667L436.667 106.333L436.333 105.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M437 105L438 106L437 105M172 106L173 107L172 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M174 106L175 107L174 106M176 106L177 107L176 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M195 106L196 107L195 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M264 106L264 112L268 109L265 111L264 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M265 106L265 111L268 109L268 108L265 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M270 106L271 107L270 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M272 106L271 113L276 112L276 111L272 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M273 106L274 107L273 106M275 106L276 107L275 106M288 106L289 107L288 106M296 106L297 107L296 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M306 106L304 112L308 112L306 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M328 106L329 107L328 106M355 106L356 107L355 106M384 106L385 107L384 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M437.333 106.667L437.667 107.333L437.333 106.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M170 107L171 108L170 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M175 107L176 108L175 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M190 107L191 108L190 107M192 107L193 108L192 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M194 107L195 108L194 107M269 107L270 108L269 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M272 107L271 108L275 112L276 111L272 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M274 107L275 108L274 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M276 107L277 108L276 107M281 107L284 110L281 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M283 107L284 108L283 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M287 107L288 108L287 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M289 107L290 108L289 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M295 107L296 108L295 107M297 107L298 108L297 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M298 107L295 112C298.84 111.693 301.049 110.37 298 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M303 107L304 108L303 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M328 107L329 108L328 107M330 107L331 108L330 107M347 107L348 108L347 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M354 107L355 108L354 107M356.333 107.667L356.667 108.333L356.333 107.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M383 107L384 108L383 107M385 107L386 108L385 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M404 107L405 108L404 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M438 107L439 108L438 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M170 108L171 109L170 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M173 108L174 109L173 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M191.667 108.333L192.333 108.667L191.667 108.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M194 108L195 109L194 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M275 108L276 109L275 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M277 108L278 109L277 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M280 108L279 109L279 111L284 111L280 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M284 108L285 109L284 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M286 108L287 109L286 108M288 108L287 110L288 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M287 112L292 112L291 108L287 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M292 108L293 109L292 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M294 108L295 109L294 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M296 108L297 109L296 108M301.667 108.333L302.333 108.667L301.667 108.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M304 108L305 109L304 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M329 108L330 109L329 108M347.333 108.667L347.667 109.333L347.333 108.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M355 108L356 109L355 108M381 108L382 109L381 108M384 108L385 109L384 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M403 108L404 109L403 108M437 108L437 110L439 108L437 108M171 109L172 110L171 109M173 109L174 110L173 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M191 109L192 110L191 109M196 109L197 110L196 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M285 109L286 110L285 109M295 109L296 110L295 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M303.333 109.667L303.667 110.333L303.333 109.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M383 109L382 119L383 119L383 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M438 109L438 115L439 115L438 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M171 110L171 114L172 114L171 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M174 110L174 114L175 114L174 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M193 110L193 114L194 114L193 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M196 110L196 114L197 114L196 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M267 110L268 111L267 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M268 110L267 112L268 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M269 110L268 112L270 112L269 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M270 110L272 112L270 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M286 110L287 111L286 110M292 110L293 111L292 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M300 110L301 111L300 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M332 110L333 111L332 110M346 110L347 111L346 110M406 110L407 111L406 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M437 110L437 114L438 114L437 110M270 111L267 112L267 113L270 111M277.333 111.667L277.667 112.333L277.333 111.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M279 111L280 112L279 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M283 111L284 112L283 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M301 111L301 113L303 113L303 111L301 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M331 111L332 112L331 111M333 111L334 112L333 111M346 111L347 112L346 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M407 111L408 112L407 111M264 112L265 113L264 112M276 112L277 113L276 112M278 112L279 113L278 112M280 112L281 113L280 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M281 112L282 113L281 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M282 112L283 113L282 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M285 112L286 113L285 112M288 112L288 113L291 113L288 112M293 112L294 113L293 112M296 112L296 113L299 113L296 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M305 112L305 113L308 113L305 112M332 112L333 113L332 112M348 112L349 113L348 112M363 112L364 113L363 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M364 112L356 114L356 115L365 113L364 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M365 112L366 113L365 112M408 112L409 113L408 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M332 113L333 114L332 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M347 113L348 114L347 113M361 113L362 114L361 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M364 113L365 114L364 113M407 113L408 114L407 113M409 113L410 114L409 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M171 114L172 115L171 114M173 114L174 115L173 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M191 114L192 115L191 114M196 114L197 115L196 114M264 114L264 126L265 126L264 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M265 114L266.028 127.397L275 129L299 129C299.001 121.299 299.332 117.102 308 117L308 114L265 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M334 114L334 117L335 117L334 114M347 114L348 115L347 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M355 114L355 115L360 116L360 115L355 114M362 114L363 115L362 114M408 114L409 115L408 114M437 114L437 116L439 116L437 114M170 115L171 116L170 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M175 115L176 116L175 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M192 115L193 116L192 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M194 115L195 116L194 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M349 115L350 116L349 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M355 115L356 116L355 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M410 115L411 116L410 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M170 116L171 117L170 116M190 116L191 117L190 116M192 116L193 117L192 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M194 116L195 117L194 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M205 116L206 117L205 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M206 116L207 117L206 116M209 116L209 117L227 117L209 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M227 116L228 117L227 116M348 116L349 117L348 116M376 116L377 117L376 116M409 116L410 117L409 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M437.333 116.667L437.667 117.333L437.333 116.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M438 116L439 117L438 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M172 117L173 118L172 117M176 117L177 118L176 117M191 117L192 118L191 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M195 117L196 118L195 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M350 117L351 118L350 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M375 117L366 125L366 126C369.964 124.464 375.1 121.697 375 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M376 117L377 118L376 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M383 117L386 129L387 129L383 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M411 117L412 118L411 117M436 117L437 118L436 117M171 118L172 119L171 118M175 118L176 119L175 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M177 118L178 119L177 118M193 118L194 119L193 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M206 118L206 129L207 129L206 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M207 118L207 129L226 129L226 118L207 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M226 118L226 129L227 129L226 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M299 118L299 129L300 129L299 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M301.667 118.333L302.333 118.667L301.667 118.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M303 118L303 119L308 119L303 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M308 118L309 119L308 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M309 118L309 119L315 119L309 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M315 118L315 119L320 119L315 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M321 118L321 130L325 130L325 129L322 129L321 118M332 118L333 119L332 118M349 118L350 119L349 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M410.667 118.333L411.333 118.667L410.667 118.333M436.667 118.333L437.333 118.667L436.667 118.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M176 119L177 120L176 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M178 119L179 120L178 119M187 119L188 120L187 119M192 119L193 120L192 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M194 119L195 120L194 119M301 119L301 129L302 129L301 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M302 119L302 129L320 129L320 119L302 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M332 119L333 120L332 119M373 119L374 120L373 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M382 119L383 120L382 119M410 119L411 120L410 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M411 119C412.486 128.919 417.381 135.079 406 141L406 142C417.824 138.478 416.598 127.854 411 119M436 119L434 123C432.544 122.216 423.19 119.096 426.175 124.421C427.1 126.07 430.492 126.827 432 128L433 128L436 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M437 119L438 120L437 119M177 120L178 121L177 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M181 120L182 121L181 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M182.667 120.333L183.333 120.667L182.667 120.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M184.667 120.333L185.333 120.667L184.667 120.333M188 120L189 121L188 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M191 120L192 121L191 120M193 120L194 121L193 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M333 120L334 121L333 120M352 120L353 121L352 120M372 120L373 121L372 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M384 120L385 121L384 120M412 120L413 121L412 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M426 120L427 121L426 120M430 120L431 121L430 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M179 121L180 122L179 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M180 121L181 122L180 121M186 121L187 122L186 121M190 121L191 122L190 121M192 121L193 122L192 121M351 121L352 122L351 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M353 121L354 122L353 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M371 121L372 122L371 121M384 121L385 122L384 121M412 121L413 122L412 121M425 121L426 122L425 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M426 124L427 124L429 122L426 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M429 121L430 122L429 121M431 121L432 122L431 121M434 121L435 122L434 121M177 122L178 123L177 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M188 122L189 123L188 122M191 122L192 123L191 122M331 122L332 123L331 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M352 122L353 123L352 122M383 122L384 123L383 122M411 122L412 123L411 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M427 122L431 125L427 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M430 122L431 123L430 122M432.667 122.333L433.333 122.667L432.667 122.333M435 122L436 123L435 122M176 123L177 124L176 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M179.333 123.667L179.667 124.333L179.333 123.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M180.667 123.333L181.333 123.667L180.667 123.333M185 123L186 124L185 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M186 123L187 124L186 123M189 123L190 124L189 123M331 123L332 124L331 123M353 123L354 124L353 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M368 123L369 124L368 123M383 123L384 124L383 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M434 123L435 124L434 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M178 124L179 125L178 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M187 124L188 125L187 124M332 124L332 127L333 127L332 124M356 124L357 125L356 124M367 124L368 125L367 124M369 124L370 125L369 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M385 124L386 125L385 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M413 124L414 125L413 124M433 124L434 125L433 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M182 125L182 126L185 126L182 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M355 125L356 126L355 125M358 125L359 126L358 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M364 125L365 126L364 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M365.333 125.667L365.667 126.333L365.333 125.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M368 125L369 126L368 125M386 125L387 129L361 134L361 129C355.032 133.975 355.655 147.882 363.044 151.821C372.066 156.63 383.856 148.656 388.095 141C391.251 135.3 393.998 127.375 386 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M412 125L413 126L412 125M264 126L265 127L264 126M357 126L358 127L357 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M366 126L367 127L366 126M384 126L385 127L384 126M414 126L415 127L414 126M427 126L428 127L427 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M428.667 126.333L429.333 126.667L428.667 126.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M430.667 126.333L431.333 126.667L430.667 126.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M263 127L264 128L263 127M331 127L332 128L331 127M361 127L362 128L361 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M362 127L363 128L362 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M386 127L387 128L386 127M413 127L414 128L413 127M431 127L431 129L433 129L431 127M265 128L266 129L265 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M331 128L332 129L331 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M360 128L361 129L360 128M385 128L386 129L385 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M415 128L416 129L415 128M134 129L134 130L159 130L134 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M160 129L161 130L160 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M228 129L228 130L265 130C255.202 125.889 238.649 129 228 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M267 129L267 130L300 130L267 129M333 129L334 130L333 129M415 129L416 130L415 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M431 129L420 144C424.966 141.129 432.792 135.559 431 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M432 129L433 130L432 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M132 130L133 131L132 130M162 130L162 131L205 131C193.774 126.29 174.219 130 162 130M326 130L327 131L326 130M334 130L335 131L334 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M362 130L362 133L363 133L362 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M414 130L415 131L414 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M131 131L132 132L131 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M327 131L328 132L327 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M414 131L415 132L414 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M430 131L431 132L430 131M335 132L336 133L335 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M391 132C389.46 140.638 383.409 148.78 375 151.867C364.719 155.64 355.62 148.977 358 138C353.065 142.313 357.709 151.729 363.04 153.732C374.035 157.863 396.055 145.088 391 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M392.333 132.667L392.667 133.333L392.333 132.667M414.333 132.667L414.667 133.333L414.333 132.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M431 132L432 133L431 132M328 133L329 134L328 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M336 133L337 134L336 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M393 133C389.809 140.155 386.928 146.471 380 150.867C367.326 158.907 356.042 152.62 356 138C349.709 139.717 341.125 141.994 336.174 146.454C329.242 152.698 326.803 165.52 323.681 174C322.629 176.86 320.501 180.686 322.071 183.699C324.478 188.321 331.498 190.253 336 192C332.55 181.115 334.554 166.364 343 158C336.74 173.055 335.623 182.038 338.625 198C339.258 201.368 337.993 206.286 340.318 209.107C343.222 212.631 350.943 211.976 355 212.001C369.041 212.086 382.672 213.133 396 208C396.48 193.253 395.744 171.505 406 160C402.773 166.159 394.117 185.091 403.306 189.928C410.016 193.461 427.566 176.514 427.302 170C426.87 159.332 412.709 150.974 410 141L405 142L395 135C390.792 144.316 385.956 152.088 376 156.07C362.967 161.284 351.671 153.124 354 139L355 139C355.003 143.4 354.619 148.217 357.514 151.891C368.25 165.519 394.302 147.303 393 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M429 133L430 134L429 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M336 134L337 135L336 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M393 134C389.269 154.919 355.019 167.804 355 139L354 139C354 142.552 353.519 146.578 354.703 149.985C357.321 157.521 365.184 158.553 372 157.192C384.616 154.673 391.557 145.876 395 134L393 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M415 134L416 135L415 134M430 134L431 135L430 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M334 135L335 136L334 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M390 135L391 136L390 135M394 135L395 136L394 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M413 135L414 136L413 135M415 135L416 136L415 135M327 136L328 137L327 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M334 136L335 137L334 136M414 136L415 137L414 136M427 136L428 137L427 136M133 137L134 138L133 137M325 137L326 138L325 137M335.333 137.667L335.667 138.333L335.333 137.667M356.667 137.333L357.333 137.667L356.667 137.333M392 137L393 138L392 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M426 137L427 138L426 137M428 137L429 138L428 137M425 138L426 139L425 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M427 138L428 139L427 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M334 139L335 140L334 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M357 139L358 140L357 139M390 139L391 140L390 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M409 139L410 140L409 139M424 139L425 140L424 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M426 139L427 140L426 139M336 140L337 141L336 140M406.667 140.333L407.333 140.667L406.667 140.333M410 140L411 141L410 140M423 140L424 141L423 140M425 140L426 141L425 140M335 141L336 142L335 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M337 141L338 142L337 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M353 141L353 146L354 146L353 141M389 141L390 142L389 141M392 141L393 142L392 141M405 141L406 142L405 141M408 141L409 142L408 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M421 141L422 142L421 141M424 141L425 142L424 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M336 142L337 143L336 142M338 142L339 143L338 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M419 142L420 143L419 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M422 142L423 143L422 142M337 143L338 144L337 143M341 143L342 144L341 143M357.333 143.667L357.667 144.333L357.333 143.667M386 143L387 144L386 143M419 143L420 144L419 143M340 144L341 145L340 144M387 144L388 145L387 144M356 146L357 147L356 146M387 146L388 147L387 146M358 147L359 148L358 147M386 147L387 148L386 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M274 148L268 165L269 165L269 162L280 173C275.895 166.996 270.249 162.68 270 155L271 155L277 164L272 152L273 152L278 164L279 164L275 149L276 149C277.906 157.236 280.952 164.361 290 166L290 165L286 154L287 154L301 170L302 170L288 153L286 153L286 164L276 148L274 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M276 148L277 149L276 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M355 148L356 149L355 148M273.333 149.667L273.667 150.333L273.333 149.667M275 149L276 150L275 149M359 149L360 150L359 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M275 150L280 164L274 155L273 155L277 165L271 156L270 156C270.864 161.463 274.587 169.198 280.09 171.397C287.682 174.43 299.773 173.233 300 185C292.36 172.116 279.027 175.833 271 163L270 163C270.582 168.804 272.999 177.257 278.188 180.586C283.348 183.896 291.266 184.171 295.182 189.225C302.091 198.14 304.458 221.842 319 221.913C331.637 221.975 344.731 206.346 337.543 194.214C335.003 189.926 327.467 187.623 323 186L319 192L319 193L328 204L302.603 178.715L299.258 167.39L287 155L286 155L291 167C280.766 163.635 280.716 157.639 275 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M277 150L278 151L277 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M358 150L359 151L358 150M360 150L361 151L360 150M378 150L379 151L378 150M383 150L384 151L383 150M271 151L272 152L271 151M276 151L277 152L276 151M361 151L362 152L361 151M376 151L377 152L376 151M379 151L380 152L379 151M384 151L385 152L384 151M272 152L274 154L272 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M286 152L287 153L286 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M357 152L358 153L357 152M363 152L364 153L363 152M373 152L374 153L373 152M377 152L378 153L377 152M380 152L381 153L380 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M272 153L272 156L274 155L274 154L272 153M275 153L276 154L275 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M278 153L279 154L278 153M285 153L286 154L285 153M356 153L357 154L356 153M358 153L359 154L358 153M378 153L379 154L378 153M268 154L268 157L269 157L268 154M275.333 154.667L275.667 155.333L275.333 154.667M277 154L278 155L277 154M286 154L287 155L286 154M288 154L289 155L288 154M359 154L360 155L359 154M364.667 154.333L365.333 154.667L364.667 154.333M369.667 154.333L370.333 154.667L369.667 154.333M376 154L377 155L376 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M120 155L121 156L120 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M121.667 155.333L122.333 155.667L121.667 155.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M88 194L87 194C92.8743 171.788 68.7719 154.438 51.1049 172.105C34.0618 189.148 52.8148 204.212 50.811 222C49.0716 237.44 32.5475 250.345 42.9946 266.996C54.8012 285.814 71.0403 273.126 83.1698 264.603C86.3137 262.393 90.558 262.789 93.9599 261C101.874 256.838 103.324 246.863 101 239C110.412 242.213 111 246.764 111 256L112 256L111 242C123.112 241.445 133.257 231.544 136 220L140 222L140 221C133.678 215.706 132.886 202.187 144 204L144 203L140 202C141.397 188.928 155.437 159.798 163 186C164.366 181.019 160.005 176.043 157.464 172C155.32 168.589 154.424 164.286 151.606 161.34C144.975 154.409 130.789 154.061 122 155.615C109.145 157.887 94.5008 165.727 90.034 179C88.445 183.721 89.5841 189.001 88 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M136.667 155.333L137.333 155.667L136.667 155.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M138 155L139 156L138 155M270 155L271 156L270 155M279 155L280 156L279 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M287 155L288 156L287 155M358 155L359 156L358 155M361 155L362 156L361 155M373 155L374 156L373 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M116 156L117 157L116 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M117 156L118 157L117 156M142 156L143 157L142 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M274 156L275 157L274 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M279 156L280 157L279 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M286 156L286 159L287 159L286 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M289 156L290 157L289 156M365 156L365 157L369 157L365 156M375 156L376 157L375 156M113 157L114 158L113 157M145 157L146 158L145 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M268.333 157.667L268.667 158.333L268.333 157.667M273 157L274 158L273 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M276 157L277 158L276 157M278 157L279 158L278 157M288 157L289 158L288 157M362 157L363 158L362 157M370.667 157.333L371.333 157.667L370.667 157.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M110 158L111 159L110 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M111 158L112 159L111 158M272 158L273 159L272 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M275 158L276 159L275 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M280 158L281 159L280 158M290 158L291 159L290 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M341 158C336.685 169.126 331.54 180.092 336 192L337 192L336.746 174L341 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M342.333 158.667L342.667 159.333L342.333 158.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M108 159L109 160L108 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M149 159L150 160L149 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M270.333 159.667L270.667 160.333L270.333 159.667M274 159L275 160L274 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M277 159L278 160L277 159M279 159L280 160L279 159M286.333 159.667L286.667 160.333L286.333 159.667M289 159L290 160L289 159M273 160L274 161L273 160M276 160L277 161L276 160M281 160L282 161L281 160M405 160L406 161L405 160M105 161L106 162L105 161M268 161L269 162L268 161M270 161L271 162L270 161M275 161L276 162L275 161M278 161L279 162L278 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M280 161L281 162L280 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M282 161L283 162L282 161M285 161L286 162L285 161M341 161L342 162L341 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M404 161C399.532 168.691 398.073 177.165 398 186L399 186L406 161L404 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M269 162L270 163L269 162M271 162L272 163L271 162M274 162L275 163L274 162M277 162L278 163L277 162M281 162L282 163L281 162M283 162L284 163L283 162M294 162L295 163L294 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M102 163L103 164L102 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M153 163L154 164L153 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M269.333 163.667L269.667 164.333L269.333 163.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M272 163L273 164L272 163M279 163L280 164L279 163M282 163L283 164L282 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M285 163L286 164L285 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M287 163L288 164L287 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M293 163L294 164L293 163M297 163L298 164L297 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M340 163L341 164L340 163M402 163L403 164L402 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M65 164L65 165L71 165L65 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M101 164L102 165L101 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M154 164L155 165L154 164M271 164L272 165L271 164M273 164L274 165L273 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M276 164L277 165L276 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M283 164L284 165L283 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M284 164L285 165L284 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M288 164L289 165L288 164M295 164L296 165L295 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M338 164L339 165L338 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M61 165L62 166L61 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M62 165L63 166L62 165M74 165L75 166L74 165M154 165L155 166L154 165M268.667 165.333L269.333 165.667L268.667 165.333M272 165L273 166L272 165M286 165L287 166L286 165M290 165L289 167L291 167L290 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M297 165L298 166L297 165M300 165L301 166L300 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M401 165L402 166L401 165M59 166L60 167L59 166M76 166L77 167L76 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M268 166L269 167L268 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M269 166L270 170L271 170L269 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M299 166L300 167L299 166M402 166L403 167L402 166M57 167L58 168L57 167M78 167L79 168L78 167M270 167L271 168L270 167M275 167L276 168L275 167M301 167L302 168L301 167M55 168L56 169L55 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M80 168L81 169L80 168M155.333 168.667L155.667 169.333L155.333 168.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M269 168L270 169L269 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M274 168L275 169L274 168M276 168L277 169L276 168M300 168L301 169L300 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M338 168L339 169L338 168M81 169L82 170L81 169M96 169L97 170L96 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M271 169L272 170L271 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M275 169L276 170L275 169M302 169L301 172L302 169M336 169L337 170L336 169M401 169L402 170L401 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M52 170L53 171L52 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M82 170L83 171L82 170M95 170L96 171L95 170M270.667 170.333L271.333 170.667L270.667 170.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M51 171L52 172L51 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M83 171L84 172L83 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M94 171L95 172L94 171M270 171L271 172L270 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M271 171C272.447 177.036 274.868 181.139 281 183L281 182L271 171M302 171C302.052 185.658 319.235 192.977 327 204L328 204C324.519 195.041 319.26 195.053 323 185L322 185L318 192L317 192L302 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M399 171L400 172L399 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M50 172L51 173L50 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M84 172L85 173L84 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M154 172L155 173L154 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M155 172L147 178L140 201L145 206C135.279 199.574 131.462 215.598 139.133 219.971C141.892 221.544 145.133 220.68 148 220C143.603 223.148 140.958 222.543 136 221C133.807 228.452 128.456 234.513 122 238.751C119.568 240.347 114.7 241.068 113.117 243.563C111.773 245.682 111.714 256.149 113.618 257.86C116.205 260.185 121.712 260.595 125 261.349C135 263.64 145.743 266.558 156 267L155 248L148 245C161.943 249.12 165.647 238.4 168 227C163.411 227.956 160.343 227.226 158 223C167.071 229.524 171.555 221.04 170.828 212C170.481 207.688 167.507 204.056 166.22 200C163.05 190.012 162.915 179.852 155 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M157 172L158 173L157 172M272 172L273 173L272 172M279 174L282 172L279 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M282.667 172.333L283.333 172.667L282.667 172.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M284 172L284 173L288 173L284 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M288 172L289 173L288 172M301 172L301 177L302 177L301 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M335 172L336 173L335 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M85 173L86 174L85 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M153 173L154 174L153 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M156 173L157 174L156 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M158 173L159 174L158 173M271 173L272 174L271 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M281 173L281 174C289.471 174.006 295.338 175.745 299 184C300.928 174.07 287.681 173.001 281 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M291 173L292 174L291 173M426 173L427 174L426 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M427 173C429.172 178.731 434.647 183.713 435.17 190C436.372 204.477 419.075 211.681 414.606 223.17C411.743 230.532 418.719 236.283 412 243L413 235L412 235C411.065 239.457 410.194 242.801 406 245L408 236L407 236C406.33 240.95 405.299 244.214 401 247L403 233L402 233C401.953 238.551 401.292 242.225 397 246L397 229L396 229L394 234L389 232L389 238L395 233C397.558 238.317 396.732 242.537 395 248C403.184 250.372 415.112 247.9 416.656 238C417.375 233.391 414.091 228.35 416.067 224C422.778 209.225 443.893 199.863 433.121 181C431.421 178.023 429.433 175.393 427 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M92 174L93 175L92 174M152 174L153 175L152 174M157 174L158 175L157 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M273 174L274 175L273 174M289 174L290 175L289 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M290 174L291 175L290 174M293 174L294 175L293 174M336 174L337 175L336 174M400 174L401 175L400 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M426 174L409 189L410 193L419 188L419 189C409.398 194.089 405.448 207.716 405 218C395.924 217.205 392.353 225.144 391 233L398 229L398 245L402 232L401 246C405.964 244.052 405.842 239.697 407 235L408 235L407 244C410.968 241.682 410.961 238.318 411 234L413 234L412 242C418.802 237.59 411.593 228.365 415.028 222.285C424.572 205.394 445.937 193.611 426 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M428 174L429 175L428 174M86 175L87 176L86 175M151 175L152 176L151 175M273 175L274 176L273 175M292 175L293 176L292 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M427 175L428 176L427 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M429 175L430 176L429 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M47 176L48 177L47 176M150 176L151 177L150 176M160 176L161 177L160 176M272 176L273 177L272 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M428 176L429 177L428 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M87 177L88 178L87 177M90 177L91 178L90 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M148 177L149 178L148 177M159 177L160 178L159 177M274 177L275 178L274 177M295 177L296 178L295 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M297 177L298 178L297 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M301.333 177.667L301.667 178.333L301.333 177.667M334 177L335 178L334 177M398.333 177.667L398.667 178.333L398.333 177.667M46 178L47 179L46 178M161 178L162 179L161 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M273 178L274 179L273 178M275 178L276 179L275 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M296 178L297 179L296 178M431 178L432 179L431 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M89 179L90 180L89 179M147 179L147 182L148 182L147 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M160 179L161 180L160 179M274 179L275 180L274 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M302 179L303 180L302 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M335 179L335 185L336 185L335 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M430 179L431 180L430 179M432 179L433 180L432 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M45 180L46 181L45 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M88 180L89 181L88 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M162 180L163 181L162 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M277 180L278 181L277 180M297 180L298 181L297 180M299 180L300 181L299 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M88 181L87 194L88 194C89.8735 189.56 90.8508 185.174 88 181M161 181L162 182L161 181M276 181L277 182L276 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M279 181L280 182L279 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M299 181L300 182L299 181M399 181L399 184L400 184L399 181M433 181L434 182L433 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M163 182L164 183L163 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M278 182L279 183L278 182M281.333 182.667L281.667 183.333L281.333 182.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M282 182L283 183L282 182M298 182L299 183L298 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M306 182L307 183L306 182M432 182L433 183L432 182M44 183L45 184L44 183M146 183L147 184L146 183M162 183L163 184L162 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M280 183L281 184L280 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M282 183L282 184C286.062 185.383 291.378 186.904 294.157 190.39C302.676 201.075 302.987 222.456 320 224L320 223C299.143 218.792 303.5 188.107 282 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M284 183L285 184L284 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M300 183L301 184L300 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M307 183L308 184L307 183M434 183L435 184L434 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M162 184L163 185L162 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M283 184L284 185L283 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M287 184L288 185L287 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M299 184L300 185L299 184M308 184L309 185L308 184M433 184L434 185L433 184M145 185L146 186L145 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M164 185L165 186L164 185M285 185L286 186L285 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M286 185L287 186L286 185M289 185L290 186L289 185M309 185L310 186L309 185M323 185L324 186L323 185M435 185L436 186L435 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M43.3333 186.667L43.6667 187.333L43.3333 186.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M163.667 186.333L164.333 186.667L163.667 186.333M288 186L289 187L288 186M291 186L292 187L291 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M292 186L293 187L292 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M321 186L322 187L321 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M398 186C397.76 197.638 395.593 204.567 402 215L403 215C408.015 201.708 412.521 193.165 398 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M434 186L435 187L434 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M160.667 187.333L161.333 187.667L160.667 187.333M163 187L164 188L163 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M164 187L171 210L172 210L164 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M213 187L214 188L213 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M214 187.439C160.921 195.797 170.793 280.557 224 273.568C233.6 272.307 242.601 269.161 249.985 262.699C282.077 234.614 255.336 180.93 214 187.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M228 187L229 188L228 187M290 187L291 188L290 187M294 187L295 188L294 187M320 187L321 188L320 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M334 187L335 188L334 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M436 187L437 188L436 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M43 188L43 191L44 191L43 188M142 188L143 189L142 188M159 188L160 189L159 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M160 188L152 197L153 197L161 189L160 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M161 188L162 189L161 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M165 188L166 189L165 188M232 188L233 189L232 188M292 188L293 189L292 188M295 188L296 189L295 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M321 188L322 189L321 188M416 188L418 190L416 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M417 188L418 189L417 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M418 188L419 189L418 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M436 188L437 189L436 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M157 189L158 190L157 189M160 189L161 190L160 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M165 189L166 190L165 189M294 189L295 190L294 189M319 189L320 190L319 189M336 189L337 190L336 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M412 194L407 190C410.136 196.543 407.137 200.394 406 207L407 207L417 189L412 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M435 189L435 192L436 192L435 189M156 190L157 191L156 190M158 190L159 191L158 190M164.333 190.667L164.667 191.333L164.333 190.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M203 190L204 191L203 190M238 190L239 191L238 190M294 190L295 191L294 190M318 190L319 191L318 190M320 190L321 191L320 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M155 191L156 192L155 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M157 191L158 192L157 191M240 191L241 192L240 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M296 191L297 192L296 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M317 191L318 192L317 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M319 191L320 192L319 191M409 191L410 192L409 191M154 192L155 193L154 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M164 192L165 193L164 192M199 192L200 193L199 192M242 192L243 193L242 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M295 192L296 193L295 192M408 192L409 193L408 192M436.333 192.667L436.667 193.333L436.333 192.667M43 193L43 196L44 196L43 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M141 193L142 194L141 193M153 193L154 194L153 193M155 193L156 194L155 193M166 193L167 194L166 193M297 193L298 194L297 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M317 193L318 194L317 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M319 193L320 194L319 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M411 193L412 194L411 193M154 194L155 195L154 194M166.333 194.667L166.667 195.333L166.333 194.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M245 194L246 195L245 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M297 194L298 195L297 194M318 194L319 195L318 194M320 194L321 195L320 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M412 194L413 195L412 194M434 194L435 195L434 194M140 195L141 196L140 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M152 195L153 196L152 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M296 195L297 196L296 195M319 195L320 196L319 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M321 195L322 196L321 195M434 195L435 196L434 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M43.3333 196.667L43.6667 197.333L43.3333 196.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M140 196L141 197L140 196M153 196L154 197L153 196M165 196L166 197L165 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M193 196L194 197L193 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M298 196L299 197L298 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M320 196L321 197L320 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M409 196L410 197L409 196M435 196L436 197L435 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M165 197L166 198L165 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M297 197L298 198L297 197M410 197L411 198L410 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M433 197L434 198L433 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M140 198L141 199L140 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M167 198L168 199L167 198M250 198L251 199L250 198M299 198L300 199L299 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M408 198L409 199L408 198M434 198L435 199L434 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M140 199L141 200L140 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M160 199L161 200L160 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M161 199L160 205C162.523 203.166 162.616 201.619 161 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M167 199L168 200L167 199M298 199L299 200L298 199M409 199L410 200L409 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M432 199L433 200L432 199M434 199L435 200L434 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M44 200L45 201L44 200M162 200L163 201L162 200M166 200L167 201L166 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M300 200L301 201L300 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M326 200L327 201L326 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M407 200L408 201L407 200M44 201L45 202L44 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M140 201L141 202L140 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M141 201L142 202L141 201M166 201L167 202L166 201M253 201L254 202L253 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M299 201L300 202L299 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M325 201L326 202L325 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M407 201L408 202L407 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M431 201L432 202L431 201M433 201L434 202L433 201M143 202L144 203L143 202M159 202L160 203L159 202M168 202L169 203L168 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M206.059 202.742C198.909 205.734 202 222.648 202 229C202 236.065 199.412 249.61 203.179 255.772C206.602 261.369 229.287 260.601 234.786 258.106C241.989 254.84 239 238.415 239 232C239 224.734 241.497 211.639 237.682 205.228C234.354 199.637 211.589 200.428 206.059 202.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M299 202L300 203L299 202M301 202L302 203L301 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M326 202L327 203L326 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M408 202L409 203L408 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M432 202L433 203L432 202M45 203L46 204L45 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M138 203L139 204L138 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M142 203L143 204L142 203M162 203L163 204L162 203M167 203L168 204L167 203M406 203L407 204L406 203M430 203L431 204L430 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M137 204L138 205L137 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M143.667 204.333L144.333 204.667L143.667 204.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M162 204L163 205L162 204M169 204L170 205L169 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M205.603 205.028C201.746 208.083 204 221.474 204 226C204 231.801 200.868 252.222 205.603 255.972C209.148 258.779 218.68 257 223 257C226.389 257 231.713 257.954 234.682 255.972C239.19 252.964 237 240.741 237 236C237 230.059 240.227 208.853 235.397 205.028C231.852 202.221 222.32 204 218 204C214.672 204 208.385 202.825 205.603 205.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M300 204L301 205L300 204M302 204L303 205L302 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M407 204L408 205L407 204M431 204L432 205L431 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M136 205L137 206L136 205M143 205L144 206L143 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M144 205L145 206L144 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M160 205L161 206L160 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M161 205L162 206L161 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M407 205L408 206L407 205M46 206L47 207L46 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M170 206L171 207L170 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M184 206L185 207L184 206M301 206L302 207L301 206M303 206L304 207L303 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M395 206L401 216L402 216L395 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M405 206L406 207L405 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M428 206L429 207L428 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M135 207L136 208L135 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M169 207L170 208L169 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M397 207L398 208L397 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M405 207L407 209L407 207L405 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M427 207L428 208L427 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M429 207L430 208L429 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M47 208L48 209L47 208M138 208L139 209L138 208M258 208L259 209L258 208M304 208L305 209L304 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M367 212L367 241C357.074 240.544 361.158 218.665 362 212C356.896 212 346.885 209.576 342.419 211.618C338.887 213.234 338.265 219.716 337.28 223C334.003 233.921 331.041 244.843 328.661 256C319.647 298.262 326 344.153 326 387L356 387C359.268 387 364.723 387.986 367.258 385.397C372.766 379.769 369.444 359.622 370.17 352C371.813 334.736 372.281 317.327 373.039 300C373.908 280.172 374.767 261.125 353 252L353 251C365.028 254.841 371.888 266.574 375.279 278C382.403 302.001 381 331.133 381 356C390.592 349.717 389.988 327.266 403.001 325.498C409.167 324.661 415.933 329.955 422 331C414.987 360.527 389.854 385.664 386 416L430 416C430 384.44 428.244 352.468 426.09 321C424.289 294.711 424.654 269.026 415 244C410.115 246.741 404.581 250.501 399 248L396 250L396 234C382.738 241.945 394.061 219.61 401 216L397 208L367 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M405 208L390 231L391 231C393.153 224.69 396.434 217.725 404 218L405 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M428 208L429 209L428 208M137 209L138 210L137 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M138 209L138 210L141 210L141 216L142 216L142 211L146 214L138 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M141 209L142 210L141 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M172 209L173 210L172 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M217.005 209.743C205.533 214.148 212.591 231.72 223.981 227.257C235.071 222.912 228.315 205.4 217.005 209.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M303 209L304 210L303 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M321 222L321 223C328.915 221.572 336.39 215.41 341 209L321 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M426 209L427 210L426 209M48 210L49 211L48 210M140 210L141 211L140 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M143 210L144 211L143 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M171 210L172 215L173 215L173 210L171 210M228 220L227 220C224.093 225.814 214.459 227.554 213.662 218.997C212.817 209.918 223.868 210.652 227 217C228.759 208.345 213.897 208.555 212.438 217.015C210.659 227.337 225.181 229.743 228 220M305 210L306 211L305 210M340 210C333.78 229.117 327.212 248.893 325.169 269C321.204 308.031 325 347.898 325 387L326 387C326 348.233 320.906 307.551 326.428 269C328.421 255.092 332.021 241.486 335.86 228C337.358 222.736 341.585 215.359 340 210M404 210L405 211L404 210M425 210L426 211L425 210M142 211L142 216L143 216L142 211M144 211L145 212L144 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M172.333 211.667L172.667 212.333L172.333 211.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M304 211L305 212L304 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M339 211L340 212L339 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M405.333 211.667L405.667 212.333L405.333 211.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M424 211L425 212L424 211M426 211L427 212L426 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M49 212L50 213L49 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M143 212L144 213L143 212M145 212L146 213L145 212M260 212L261 213L260 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M306 212L307 213L306 212M362 212C361.098 219.138 357.246 239.104 366 242L367 212L366 212L365 241L364 241L362 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M364 212C361.023 220.794 361.208 231.172 364 240L365 240L366 212L364 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M425 212L426 213L425 212M144 213L145 214L144 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M171 213L167 235L168 235L171 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M217.229 214.029C210.831 217.92 217.797 226.899 223.566 222.971C229.256 219.098 223.215 210.388 217.229 214.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M305 213L306 214L305 213M307 213L308 214L307 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M424 213L425 214L424 213M145 214L146 215L145 214M306 214L307 215L306 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M365.333 214.667L365.667 215.333L365.333 214.667M403 214L404 215L403 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M50 215L51 216L50 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M135 215L136 216L135 215M172 215L173 216L172 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M308 215L309 216L308 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M332 215L333 216L332 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M334 215L335 216L334 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M361 215L362 216L361 215M402 215L403 216L402 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M135 216L136 217L135 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M170 216L171 217L170 216M307 216L308 217L307 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M309 216L310 217L309 216M331 216L332 217L331 216M333 216L334 217L333 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M399 216L400 217L399 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M404 216L405 217L404 216M170 217L171 218L170 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M262 217L263 218L262 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M308 217L309 218L308 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M332 217L333 218L332 217M362 217L363 218L362 217M366.333 217.667L366.667 218.333L366.333 217.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M397 217L398 218L397 217M400 217L401 218L400 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M401 217L402 218L401 217M404 217L405 218L404 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M419 217L420 218L419 217M171 218L172 219L171 218M228 218L229 219L228 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M328 218L329 219L328 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M398 218L399 219L398 218M418 218L419 219L418 218M137 219L138 220L137 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M171 219L172 220L171 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M329 219L330 220L329 219M417 219L418 220L417 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M419 219L420 220L419 219M136 220L137 221L136 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M138 220L139 221L138 220M146 220L147 221L146 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M147 220L148 221L147 220M169 220L170 221L169 220M178 220L179 221L178 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M325 220L326 221L325 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M328 220L329 221L328 220M416 220L417 221L416 220M418 220L419 221L418 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M140.333 221.667L140.667 222.333L140.333 221.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M141 221L141 222L144 222L141 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M144 221L145 222L144 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M141 222L141 223L147 222L141 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M169 221L170 222L169 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M263 221L264 222L263 221M314 221L315 222L314 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M323 221L324 222L323 221M326 221L327 222L326 221M393 221L394 222L393 221M414 221L415 222L414 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M417 221L418 222L417 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M135 222L136 223L135 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M139 222L140 223L139 222M145 222L146 223L145 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M170 222L171 223L170 222M316 222L317 223L316 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M317.667 222.333L318.333 222.667L317.667 222.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M319 222L322 224L319 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M324 222L325 223L324 222M337 222L338 223L337 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M394 222L395 223L394 222M416 222L417 223L416 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M50 223L51 224L50 223M135 223L136 224L135 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M158 223L161 226L158 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M170 223L171 224L170 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M315 223L316 224L315 223M392 223L393 224L392 223M415 223L415 226L416 226L415 223M50 224L51 225L50 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M158 224L160 226L158 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M335 224L336 225L335 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M393 224L394 225L393 224M134 225L135 226L134 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M158 225L159 226L158 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M168 225L162 228C164.296 227.585 169.111 227.962 168 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M336 225L337 226L336 225M364 225L364 233L365 233L364 225M391 225L392 226L391 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M160.667 226.333L161.333 226.667L160.667 226.333M166 226L167 227L166 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M392 226L393 227L392 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M415 226L416 227L415 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M49 227L50 228L49 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M133 227L134 228L133 227M161 227L162 228L161 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M163 227L163 228L166 228L163 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M169 227L170 228L169 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M177 227L177 230L178 230L177 227M334 227L335 228L334 227M392 227L393 228L392 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M415.333 227.667L415.667 228.333L415.333 227.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M169 228L170 229L169 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M390 228L391 229L390 228M48 229L49 230L48 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M167 229L168 230L167 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M391 229L392 230L391 229M397 229L398 230L397 229M414.333 229.667L414.667 230.333L414.333 229.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M131 230L132 231L131 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M167 230L168 231L167 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M389 230L390 231L389 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M395 230L396 231L395 230M47 231L48 232L47 231M130 231L131 232L130 231M168 231L169 232L168 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M177.333 231.667L177.667 232.333L177.333 231.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M389 231L391 233L391 231L389 231M396 231L397 232L396 231M129 232L130 233L129 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M168 232L169 233L168 232M334 232L335 233L334 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M394 232L395 233L394 232M402 232L403 233L402 232M416 232L417 233L416 232M128 233L129 234L128 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M166 233L167 234L166 233M362 233L363 234L362 233M392.667 233.333L393.333 233.667L392.667 233.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M395 233L396 234L395 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M401.333 233.667L401.667 234.333L401.333 233.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M415.333 233.667L415.667 234.333L415.333 233.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M45 234L46 235L45 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M127 234L128 235L127 234M166 234L166 236L168 236L166 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M332 234L333 235L332 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M388 234L388 237L389 237L388 234M390.667 234.333L391.333 234.667L390.667 234.333M394 234L395 235L394 234M397 234L398 235L397 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M411 234L412 235L411 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M412 234L413 235L412 234M126 235L127 236L126 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M216.094 235.858C205.565 240.509 213.05 257.615 223.957 252.99C235.588 248.058 227.532 230.806 216.094 235.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M390 235L391 236L390 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M391 235L392 236L391 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M396 235L397 236L396 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M403 235L403 238L404 238L403 235M407 235L408 236L407 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M411 235L411 238L412 238L411 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M415 235L415 238L416 238L415 235M44 236L45 237L44 236M125 236L126 237L125 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M166 236L160 245L160 246C163.911 244.076 167.253 240.587 166 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M167 236L168 237L167 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M219 252L219 251C206.604 244.884 220.884 230.604 227 243C229.405 231.161 203.176 237.577 214.409 249.682C215.776 251.156 217.165 251.472 219 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M361 236L362 237L361 236M390 236L391 237L390 236M396 236L397 237L396 236M406 236L406 239L407 239L406 236M417 236L418 237L417 236M165 237L166 238L165 237M398.333 237.667L398.667 238.333L398.333 237.667M43 238L44 239L43 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M122 238L123 239L122 238M165 238L166 239L165 238M225 249L225 250L222 251L222 252L228 246L227 246L226 249C225.884 247.098 226.12 244.895 225.656 243.039C222.458 230.247 206.58 248.596 219.991 249.762C221.702 249.91 223.362 249.384 225 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M263 238L264 239L263 238M331 238L332 239L331 238M401.333 238.667L401.667 239.333L401.333 238.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M412.333 238.667L412.667 239.333L412.333 238.667M415 238L416 239L415 238M101 239L102 240L101 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M102 239L103 240L102 239M121 239L122 240L121 239M166 239L167 240L166 239M178 239L179 240L178 239M332 239L333 240L332 239M363 239L364 240L363 239M366.333 239.667L366.667 240.333L366.333 239.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M398 239L399 240L398 239M406 239L407 240L406 239M416 239L417 240L416 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M42 240L43 241L42 240M104 240L105 241L104 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M105 240L106 241L105 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M119 240L120 241L119 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M164 240L165 241L164 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M364 240L365 241L364 240M398.333 240.667L398.667 241.333L398.333 240.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M401 240L402 241L401 240M407 240L408 241L407 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M412 240L413 241L412 240M416 240L417 241L416 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M42 241L43 242L42 241M107 241L108 242L107 241M116 241L117 242L116 241M165 241L166 242L165 241M402 241L403 242L402 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M407 241L408 242L407 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M410 241L411 242L410 241M414 241L415 242L414 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M102 242L103 243L102 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M111.333 242.667L111.667 243.333L111.333 242.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M112 242L113 243L112 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M163 242L164 243L163 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M396 242L397 243L396 242M405 242L406 243L405 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M412 242L413 243L412 242M415 242C416.307 255.042 422.399 267.646 423.834 281C428.642 325.745 430 371.996 430 417L422 417L422 418L431 418C431 377.882 429.968 336.913 426.17 297C424.493 279.377 425.226 257.403 415 242M41 243L42 244L41 243M102 243L102 247L103 247L102 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M162 243L163 244L162 243M164 243L165 244L164 243M179 243L180 244L179 243M331 243L332 244L331 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M396 243L397 244L396 243M400 243L401 244L400 243M405 243L406 244L405 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M409 243L410 244L409 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M110 244L111 245L110 244M161 244L162 245L161 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M163 244L164 245L163 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M228 244L229 245L228 244M397.333 244.667L397.667 245.333L397.333 244.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M399 244L400 245L399 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M401 244L402 245L401 244M406.667 244.333L407.333 244.667L406.667 244.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M408 244L409 245L408 244M110.333 245.667L110.667 246.333L110.333 245.667M148 245L149 246L148 245M158 245L159 246L158 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M159.333 245.667L159.667 246.333L159.333 245.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M162 245L163 246L162 245M261 245L262 246L261 245M395 245L396 246L395 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M403.667 245.333L404.333 245.667L403.667 245.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M40 246L41 247L40 246M112.333 246.667L112.667 247.333L112.333 246.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M148 246L148 247L156 247L156 268L157 268C156.699 260.993 153.927 252.834 159 247L148 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M152.667 246.333L153.333 246.667L152.667 246.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M160 246L161 247L160 246M180 246L181 247L180 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M395 246L396 247L395 246M398 246L399 247L398 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M401 246L402 247L401 246M409 246L410 247L409 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M410.667 246.333L411.333 246.667L410.667 246.333M40 247L41 248L40 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M102.333 247.667L102.667 248.333L102.333 247.667M149 247L150 248L149 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M150.667 247.333L151.333 247.667L150.667 247.333M154.667 247.333L155.333 247.667L154.667 247.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M157 247L158 248L157 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M402 247L403 248L402 247M112 248L112 252L113 252L112 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M155 248L156 249L155 248M181 248L182 249L181 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M395 248L396 249L395 248M404 248L405 249L404 248M406 248L407 249L406 248M155 249L156 250L155 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M396.667 249.333L397.333 249.667L396.667 249.333M400 249L401 250L400 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M402 249L403 250L402 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M39.3333 250.667L39.6667 251.333L39.3333 250.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M156.333 250.667L156.667 251.333L156.333 250.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M182 250L183 251L182 250M328 250L329 251L328 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M101 251L102 252L101 251M353 251L353 252C374.924 262.432 373.937 281.497 373.039 302C371.875 328.592 369 355.392 369 382L370 382C374.06 350.904 375 317.367 375 286L376 286L380 360L381 360L383 356C379.749 356 381 351.718 381 349C381 341.241 380 333.782 380 326C380 304.139 381.343 256.967 353 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M355 251L356 252L355 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M39 252L39 257L40 257L39 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M101 252L102 253L101 252M112.333 252.667L112.667 253.333L112.333 252.667M156 252L156 259L157 259L156 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M220 252L221 253L220 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M329 252L330 253L329 252M354 252L355 253L354 252M357 252L358 253L357 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15a36b",
      stroke: "none"
    },
    d: "M99 276C90.1553 281.197 84.1705 295.045 79.7562 304C65.1268 333.679 60.5791 368.454 65.9198 401C67.4952 410.601 69.5013 432.183 78 438C63.2458 394.387 61.013 353.243 79.0116 310C84.1414 297.675 93.135 287.79 99 276C120.653 283.33 146.937 279.034 167.96 287.738C174.859 290.595 179.69 302.034 183.667 308C196.656 327.484 211.895 349.239 206 374L207 374C218.57 346.581 190.063 313.78 176.029 293C172.077 287.147 173.146 274.858 167.721 270.938C162.792 267.374 153.847 266.969 148 265.8C134.995 263.2 121.998 259.209 109 257L109 258L149 267.8L166.57 272.728L170 286C147.386 283.139 120.417 281.82 99 274C101.155 267.388 103.123 256.282 111 255L111 253C102.228 254.358 96.9987 267.991 99 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M257 253L258 254L257 253M356 253L357 254L356 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M100 254L101 255L100 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M327 254L328 255L327 254M360 254L361 255L360 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M99 274L124 279.08L170 286L167.272 272.728L151 268L109 259L110 255C102.705 256.254 100.459 267.698 99 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M110 255L110 257L112 257L110 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M185 255L186 256L185 255M99 256L100 257L99 256M255 256L256 257L255 256M39.3333 257.667L39.6667 258.333L39.3333 257.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M98 257L99 258L98 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M419 257L420 258L419 257M109 258L110 259L109 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M96 259L97 260L96 259M156 259L156 263L157 263L156 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M421 259L422 260L421 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M95 260L96 261L95 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M326 260L327 261L326 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M40 261L41 262L40 261M93 261L94 262L93 261M90 262L91 263L90 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M91 262L92 263L91 262M327 262L328 263L327 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M83 263L84 264L83 263M155.333 263.667L155.667 264.333L155.333 263.667M284.667 263.333L285.333 263.667L284.667 263.333M41 264L42 265L41 264M82 264L83 265L82 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M247 264L248 265L247 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M266 294C266.453 290.417 265.797 271.827 260 282L261 282L262 279L263 279L259 286L260 283L259 283C253.806 297.076 244.981 305.023 247 321L248 321C247.165 310.328 249.212 303.096 255.054 294.001C257.996 289.42 263.129 286.484 264 281L265 281C266.282 286.449 266.307 292.91 261 296L261 297C274.219 295.528 276.493 278.676 282 269L287 272L283 286L284 286L287 264C275.852 265.814 274.94 287.358 266 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M368 264L369 265L368 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M81 265L82 266L81 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M155 265L156 266L155 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M284 265L284 271L285 271L284 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M285 265L286 266L285 265M42 266L43 267L42 266M157 266L158 267L157 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M281 266L282 267L281 266M283 266L283 270L284 270L283 266M287.333 266.667L287.667 267.333L287.333 266.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M325 266L326 267L325 266M80 267L81 268L80 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M157 267L158 268L157 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M198 267L199 268L198 267M79 268L80 269L79 268M241 268L242 269L241 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M280 268L281 269L280 268M286.333 268.667L286.667 269.333L286.333 268.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M326.333 268.667L326.667 269.333L326.333 268.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M78 269L79 270L78 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M202 269L203 270L202 269M239 269L240 270L239 269M281 269L282 270L281 269M423 269L424 270L423 269M45 270L46 271L45 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M77 270L78 271L77 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M204 270L205 271L204 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M279 270L280 271L279 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M281 270C277.305 279.525 272.755 297.473 260 297C264.993 293.429 264.996 289.818 265 284L264 284C253.181 296.912 244.351 307.18 250 325L255 322L217.59 363L205.878 379L211 391L194 368L152 396C154.864 404.635 162.688 412.638 169.004 418.999C175.491 425.533 183.366 433.295 192 436.914C208.433 443.804 224.936 434.286 235.076 422C253.269 399.959 264.607 369.633 271 342L268 342C277.481 335.21 302.898 323.854 294 309L288 315C290.939 310.427 293.405 305.991 290 301L286 305C290.083 298.115 291.866 292.175 283 289L281 296L286 272L281 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M282 270L283 271L282 270M285 270L286 271L285 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M46 271L47 272L46 271M76 271L77 272L76 271M207 271L208 272L207 271M234 271L235 272L234 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M280 271L281 272L280 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M282 271L283 272L282 271M422 271L423 272L422 271M230 272L231 273L230 272M278 272L279 273L278 272M284 272L285 273L284 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M286 272L287 273L286 272M49 273L50 274L49 273M73 273L74 274L73 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M216.667 273.333L217.333 273.667L216.667 273.333M224.667 273.333L225.333 273.667L224.667 273.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M279 273L280 274L279 273M287.333 273.667L287.667 274.333L287.333 273.667M71 274L72 275L71 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M277 274L278 275L277 274M324 274L324 277L325 277L324 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M53 275L54 276L53 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M69 275L70 276L69 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M277 275L278 276L277 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M287 275L288 276L287 275M424 275L425 276L424 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M56.6667 276.333L57.3333 276.667L56.6667 276.333M65 276L66 277L65 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M66 276L67 277L66 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M99 276C73.0015 312.299 60.8815 353.451 67 398C68.272 407.261 70.1745 431.238 78.4992 436.972C84.6003 441.175 101.679 438 109 438L190 438L190 437C174.844 429.79 159.102 412.535 151 398L142 400L142 399C150.337 398.395 157.305 391.507 164 387C171.726 381.798 189.986 373.467 193.879 364.907C195.932 360.393 191.102 352.225 189.396 348C183.614 333.683 174.248 319.745 170 305L171 305C175.249 319.748 184.857 333.643 190.6 348C192.87 353.675 197.163 361.018 195 367L195 368L203 378C213.593 367.386 204.933 343.219 199.244 332C193.72 321.106 186.429 311.143 179.667 301C176.954 296.931 174.182 290.687 169.816 288.178C163.757 284.698 152.892 284.839 146 283.87C130.445 281.682 114.211 279.935 99 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M216 276L214 279L218 278L216 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M217 276L218 277L217 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M278 276L279 277L278 276M285 276L286 277L285 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M216 277L202 288C201.303 278.867 193.626 284.227 200 288C197.395 294.871 192.665 301.146 185 302L185 303C195.048 302.45 196.172 294.086 203.21 289.07C207.904 285.725 215.146 283.528 216 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M276 277L277 278L276 277M285 277L286 278L285 277M216 278L217 279L216 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M261 278L262 279L261 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M264 278L265 279L264 278M277 278L278 279L277 278M286 278L287 279L286 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M375 278L376 279L375 278M423 278L424 279L423 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M215 279L216 280L215 279M260 279L261 280L260 279M262 279L261 281L262 279M265 279L266 280L265 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M275 279L276 280L275 279M325 279L325 282L326 282L325 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M262 280L260 286L262 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M276 280L277 281L276 280M284 280L285 281L284 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M374 280L375 281L374 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M197 281L198 282L197 281M200 281L201 282L200 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M259 281L260 282L259 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M264 281L266 284L264 281M266 281L267 282L266 281M285 281L286 282L285 281M196 282L197 283L196 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M198 282L199 283L198 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M199 282L201 284L199 282M201 282L202 283L201 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M210 282L211 283L210 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M259.667 282.333L260.333 282.667L259.667 282.333M274 282L275 283L274 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M283 282L284 283L283 282M376 282L377 283L376 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M197.333 283.667L197.667 284.333L197.333 283.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M198 283L200 287L198 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M209 283L210 284L209 283M260 283L261 284L260 283M264 283L265 284L264 283M275 283L276 284L275 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M283 283L284 284L283 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M425 283L425 286L426 286L425 283M200 284L201 285L200 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M208 284L209 285L208 284M210 284L211 285L210 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M258 284L259 285L258 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M262 284L263 285L262 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M265 284L265 288L266 288L265 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M273 284L274 285L273 284M284 284L285 285L284 284M196 285L197 286L196 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M202 285L203 286L202 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M209 285L210 286L209 285M259 285L260 286L259 285M261 285L262 286L261 285M263 285L264 286L263 285M274 285L275 286L274 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M282 285L283 286L282 285M200 286L201 287L200 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M205 286L206 287L205 286M262 286L263 287L262 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M272 286L273 287L272 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M282 286L284 288L284 286L282 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M375 286L376 287L375 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M202 287L203 288L202 287M206 287L207 288L206 287M257 287L258 288L257 287M259 287L260 288L259 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M260 287L261 288L260 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M273 287L274 288L273 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M282 287L281 295L282 295C282.897 289.428 288.534 289.009 289.627 295.015C290.282 298.611 287.621 302.029 286 305L290 300L291 300C292.432 306.505 291.568 309.395 288 315L293 308C305.662 321.103 277.977 334.944 269 341L270 348L271 348C274.375 333.471 294.073 332.065 297.552 318C299.128 311.628 293.878 305.837 292.351 300C290.433 292.671 289.601 289.601 282 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M375 287C375 316.784 375.433 350.736 370 380L371 380C373.602 373.751 378.174 367.641 379.61 361C382.416 348.02 378.338 332.197 378.015 319C377.777 309.284 379.274 295.894 375 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M377.333 287.667L377.667 288.333L377.333 287.667M424 287L424 290L425 290L424 287M199 288L200 289L199 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M203 288L204 289L203 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M204 288L205 289L204 288M258 288L259 289L258 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M265.333 288.667L265.667 289.333L265.333 288.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M271 288L272 289L271 288M281 288L282 289L281 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M286 288L287 289L286 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M201 289L202 290L201 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M272 289L273 290L272 289M281 289L282 290L281 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M284 289L285 290L284 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M285 289L286 290L285 289M288 289L289 290L288 289M199 290L200 291L199 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M255 290L256 291L255 290M257 290L258 291L257 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M266.333 290.667L266.667 291.333L266.333 290.667M270 290L271 291L270 290M282 290L283 291L282 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M287 290L288 291L287 290M376.333 290.667L376.667 291.333L376.333 290.667M200 291L201 292L200 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M256 291L257 292L256 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M269 291L270 292L269 291M271 291L272 292L271 291M282.333 291.667L282.667 292.333L282.333 291.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M290 291L291 292L290 291M254 292L255 293L254 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M266 292L267 293L266 292M268 292L269 293L268 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M270 292L271 293L270 292M289 292L290 293L289 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M323 292L323 338L324 338C324 324.997 328.01 303.939 323 292M197 293L198 294L197 293M253 293L254 294L253 293M255 293L256 294L255 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M264 293L265 294L264 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M266 293L267 294L266 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M267 293L268 294L267 293M269 293L270 294L269 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M280.333 293.667L280.667 294.333L280.333 293.667M291 293L292 294L291 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M198 294L199 295L198 294M254 294L255 295L254 294M268 294L269 295L268 294M291.333 294.667L291.667 295.333L291.333 294.667M252 295L253 296L252 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M262.667 295.333L263.333 295.667L262.667 295.333M267 295L268 296L267 295M281 295L282 296L281 295M373 295L373 298L374 298L373 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M195 296L196 297L195 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M251 296L252 297L251 296M253 296L254 297L253 296M260 296L261 297L260 296M265 296L266 297L265 296M426 296L426 300L427 300L426 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M196 297L197 298L196 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M261 297L262 298L261 297M378 297L378 300L379 300L378 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M195 298L196 299L195 298M250 298L251 299L250 298M194 299L195 300L194 299M251 299L252 300L251 299M289 299L290 300L289 299M191 300L192 301L191 300M193 300L194 301L193 300M249 300L250 301L249 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M290 300L291 301L290 300M292 300L293 301L292 300M189 301L190 302L189 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M192 301L193 302L192 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M250 301L251 302L250 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M292 301L293 302L292 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M374 301L374 304L375 304L374 301M377 301L377 305L378 305L377 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15a36b",
      stroke: "none"
    },
    d: "M113 302C102.917 328.182 111.734 354.014 125.601 377C130.161 384.558 134.928 393.575 142 399C132.447 378.805 117.071 363.514 111.887 341C110.161 333.503 109.329 325.656 110.428 318C111.138 313.058 114.407 306.759 113 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M190 302L191 303L190 302M248 302L249 303L248 302M287 302L288 303L287 302M291 302L292 303L291 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M425 302L425 306L426 306L425 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M185 303L185 304L188 304L185 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M188 303L189 304L188 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M249 303L250 304L249 303M286 303L287 304L286 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M288 303L289 304L288 303M293 303L294 304L293 303M247 304L248 305L247 304M287 304L288 305L287 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15a36b",
      stroke: "none"
    },
    d: "M170 305C172.512 319.094 182.999 333.701 188.576 347C190.326 351.173 195.198 359.422 193.644 363.96C192.22 368.116 186.358 370.75 183 373.141C173.528 379.886 157.049 387.002 151 397C163.012 391.317 174.114 381.899 185 374.28C188.008 372.175 195.265 368.589 196.201 364.737C197.247 360.435 192.973 352.968 191.399 349C185.775 334.825 179.784 316.808 170 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M247 305L248 306L247 305M292 305L292 308L293 308L292 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M294 305L295 306L294 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M248 306L249 307L248 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M295 307L296 308L295 307M246 308L247 309L246 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M293.667 308.333L294.333 308.667L293.667 308.333M246 309L247 310L246 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M291 309L292 310L291 309M296 309L297 310L296 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M291 310L292 311L291 310M295 310L296 311L295 310M247 311L247 317L248 317L247 311M290 311L291 312L290 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M292 311L293 312L292 311M295 311L296 312L295 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M291 312L292 313L291 312M297 312L298 313L297 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M288 313L289 314L288 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M290 313L291 314L290 313M296.333 313.667L296.667 314.333L296.333 313.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M372 313L372 316L373 316L372 313M379 313L379 318L380 318L379 313M427 313L427 318L428 318L427 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M289 314L290 315L289 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M296 315L296 319L297 319L296 315M298 316L299 317L298 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M246.333 317.667L246.667 318.333L246.333 317.667M297 319L298 320L297 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M248 320L249 321L248 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M295 320L296 321L295 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M373 320L373 323L374 323L373 320M378 320L378 325L379 325L378 320M426 320L426 325L427 325L426 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M247 321L247 323L249 321L247 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M294 321L295 322L294 321M296 321L297 322L296 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M248 322C248.222 329.083 241.088 334.015 236.715 339C225.726 351.528 212.858 363.836 204 378L203 378L193 367L209 390L210 390L205.738 378.576L217.92 363L254 323L250 325L248 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M254 322L255 323L254 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M295 322L296 323L295 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M249 323L250 324L249 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M252 323L253 324L252 323M254 323L255 324L254 323M294 323L295 324L294 323M248 324L249 325L248 324M251 324L252 325L251 324M253 324L254 325L253 324M293 324L294 325L293 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M290 325L291 326L290 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M292 325L293 326L292 325M401.667 325.333L402.333 325.667L401.667 325.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M254 438L220 438C238.031 422.25 253.553 402.57 260 379L259 379C249.187 404.294 227.289 449.397 193 437.182C175.724 431.028 160.875 410.516 151 396L150 396C156.114 411.896 174.789 429.772 190 437L190 438C151.133 438 109.597 433.767 71.0008 438.109C61.0646 439.226 60.2647 454.595 68 459C64.446 453.007 60.9186 443.066 70.0154 439.603C76.3724 437.184 86.2475 439 93 439L144 439L373 439L433 439C439.175 439 450.594 436.83 455.772 440.742C462.448 445.788 459.108 457.98 450.999 458.891C424.064 461.917 395.121 459 368 459L69 459L69 460L362 460L433 460C439.576 460 453.778 462.7 458.258 456.772C461.853 452.014 460.895 441.163 454.956 438.742C446.448 435.275 432.146 438 423 438L422 417L421 417L422 438L418 438L417 433L414 433C408.436 441.901 389.442 438 380 438L380 437C388.498 433.268 394.445 426.481 398 418L397 418C391.395 427.115 384.111 436.018 373 438L422 332C416.462 329.728 409.182 324.961 403.001 325.718C395.678 326.614 393.074 335.346 390.247 341L374.247 373C372.348 376.789 370.246 383.578 366.585 385.972C361.589 389.24 349.826 387 344 387L285 387C274.513 387 260.213 385.145 255.228 397.001C250.599 408.013 254 426.14 254 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M405 325L406 326L405 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M406 325L407 326L406 325M289 326L290 327L289 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M291 326L292 327L291 326M399 326L400 327L399 326M408 326L409 327L408 326M288 327L289 328L288 327M290 327L291 328L290 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M397 327L398 328L397 327M411 327L412 328L411 327M289 328L290 329L289 328M396 328L397 329L396 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M413 328L414 329L413 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M285 329L286 330L285 329M416 329L417 330L416 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M246 330L247 331L246 330M284 330L285 331L284 330M286 330L287 331L286 330M395 330L396 331L395 330M418 330L419 331L418 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M285 331L286 332L285 331M371 331L371 334L372 334L371 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M420 331L421 332L420 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M421 331L422 332L421 331M281 332L282 333L281 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M394 332L395 333L394 332M280 333L281 334L280 333M282 333L283 334L282 333M421 333L422 334L421 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M278 334L279 335L278 334M281 334L282 335L281 334M380 334L380 339L381 339L380 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M393 334L394 335L393 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M428 334L428 340L429 340L428 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M277 335L278 336L277 335M279 335L280 336L279 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M275 336L276 337L275 336M278 336L279 337L278 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M392 336L393 337L392 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M420 336L421 337L420 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M274 337L275 338L274 337M276 337L277 338L276 337M237 338L238 339L237 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M272 338L273 339L272 338M275 338L276 339L275 338M372 338L372 341L373 341L372 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M391 338L392 339L391 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M419 338L420 339L419 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M236 339L237 340L236 339M271 339L272 340L271 339M273 339L274 340L273 339M235 340L236 341L235 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M237 340L238 341L237 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M390 340L391 341L390 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M418 340L419 341L418 340M234 341L235 342L234 341M236 341L237 342L236 341M268 341L269 342L268 341M379 341L379 347L380 347L379 341M233 342L234 343L233 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M235 342L236 343L235 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M269 342L270 343L269 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M272 342L273 343L272 342M389 342L390 343L389 342M417 342L418 343L417 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M427 342L427 348L428 348L427 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M234 343L235 344L234 343M233 344L234 345L233 344M270 344L271 345L270 344M388 344L389 345L388 344M416 344L417 345L416 344M271 345L272 346L271 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M271 346L272 347L271 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M387 346L388 347L387 346M415 346L416 347L415 346M229 347L230 348L229 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M269 347L270 348L269 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M228 348L229 349L228 348M269 348L271 350L271 348L269 348M386 348L387 349L386 348M414 348L415 349L414 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M227 349L228 350L227 349M229 349L230 350L229 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M269 349L267 358L268 358L269 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M370 349L370 353L371 353L370 349M414 349L415 350L414 349M226 350L227 351L226 350M228 350L229 351L228 350M268 350L269 351L268 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M385 350L386 351L385 350M227 351L228 352L227 351M268 351L269 352L268 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M413 351L414 352L413 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M226 352L227 353L226 352M269 352L270 353L269 352M384 352L385 353L384 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M269 353L270 354L269 353M412 353L413 354L412 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M267 354L268 355L267 354M383 354L384 355L383 354M222 355L223 356L222 355M268 355L269 356L268 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M411 355L412 356L411 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M221 356L222 357L221 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M223 356L224 357L223 356M268 356L269 357L268 356M371 356L371 359L372 359L371 356M381 356L382 357L381 356M220 357L221 358L220 357M222 357L223 358L222 357M266 357L267 358L266 357M325 357L325 365L326 365L325 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M410 357L411 358L410 357M221 358L222 359L221 358M266.667 358.333L267.333 358.667L266.667 358.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M429 358L429 364L430 364L429 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M220 359L221 360L220 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M266 359L265 364L266 364L266 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M267 359L268 360L267 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M409 359L410 360L409 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M265 360L266 361L265 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M217 361L218 362L217 361M265 361L266 362L265 361M408 361L409 362L408 361M216 362L217 363L216 362M266 362L267 363L266 362M379 362L380 363L379 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M215 363L216 364L215 363M217 363L218 364L217 363M264 363L265 364L264 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M407 363L408 364L407 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M214 364L215 365L214 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M216 364L217 365L216 364M264.667 364.333L265.333 364.667L264.667 364.333M378 364L379 365L378 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M407 364L408 365L407 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M215 365L216 366L215 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M264.333 365.667L264.667 366.333L264.333 365.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M265 365L266 366L265 365M263 366L264 367L263 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M377 366L378 367L377 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M406 366L407 367L406 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M263.667 367.333L264.333 367.667L263.667 367.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M428 367L428 373L429 373L428 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M211 368L212 369L211 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M263.333 368.667L263.667 369.333L263.333 368.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M264 368L265 369L264 368M324 368L324 375L325 375L324 368M369 368L369 371L370 371L369 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M376 368L377 369L376 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M405 368L406 369L405 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M196 369L197 370L196 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M210 369L211 370L210 369M212 369L213 370L212 369M262 369L263 370L262 369M195 370L196 371L195 370M197 370L198 371L197 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M208.333 370.667L208.667 371.333L208.333 370.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M209 370L210 371L209 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M211 370L212 371L211 370M262.667 370.333L263.333 370.667L262.667 370.333M375 370L376 371L375 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M404 370L405 371L404 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M196 371L197 372L196 371M210 371L211 372L210 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0c0c",
      stroke: "none"
    },
    d: "M262 371L260 378L261 378L262 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M263 371L264 372L263 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M261 372L262 373L261 372M374 372L375 373L374 372M403 372L404 373L403 372M199 373L200 374L199 373M262 373L263 374L262 373M200 374L201 375L200 374M206 374L207 375L206 374M373 374L374 375L373 374M402 374L403 375L402 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M199 375L200 376L199 375M201 375L202 376L201 375M205 375L206 376L205 375M207 375L208 376L207 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M260 375L261 376L260 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M370 375L370 378L371 378L370 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M200 376L201 377L200 376M206 376L207 377L206 376M261 376L262 377L261 376M372 376L373 377L372 376M401 376L402 377L401 376M205 377L206 378L205 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M259 377L260 378L259 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M259.667 378.333L260.333 378.667L259.667 378.333M371 378L372 379L371 378M400 378L401 379L400 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M202 379L203 380L202 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M204 379L205 380L204 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M260 379L261 380L260 379M400 379L401 380L400 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M203 380L204 381L203 380M258 380L259 381L258 380M259 381L260 382L259 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M399 381L400 382L399 381M257 382L258 383L257 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M207 383L208 384L207 383M258 383L259 384L258 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M398 383L399 384L398 383M206 384L207 385L206 384M208 384L209 385L208 384M258 384L259 385L258 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M368 384L369 385L368 384M207 385L208 386L207 385M256 385L257 386L256 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M397 385L398 386L397 385M430 385L430 392L431 392L430 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M209 386L210 387L209 386M257 386L258 387L257 386M367 386L368 387L367 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M208 387L209 388L208 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M255 387L256 388L255 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M265 387L266 388L265 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M266.667 387.333L267.333 387.667L266.667 387.333M396 387L397 388L396 387M210.333 388.667L210.667 389.333L210.333 388.667M256 388L257 389L256 388M263 388L264 389L263 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M254 389L255 390L254 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M261 389L262 390L261 389M395 389L396 390L395 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M209.667 390.333L210.333 390.667L209.667 390.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M255 390L256 391L255 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M253 391L254 392L253 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M394 391L395 392L394 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M252 393L253 394L252 393M254 393L255 394L254 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M393 393L394 394L393 393M256 394L257 395L256 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M393 394L394 395L393 394M251 395L252 396L251 395M253 395L254 396L253 395M255 395L256 396L255 395M429 395L429 401L430 401L429 395M149 396L150 397L149 396M392 396L393 397L392 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15a36b",
      stroke: "none"
    },
    d: "M142 399L142 400C145.749 400.696 147.489 399.839 150 397L142 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M250 397L251 398L250 397M252 397L253 398L252 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M152 398L153 399L152 398M250 398L251 399L250 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M254 398L255 399L254 398M391 398L392 399L391 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M151 399L152 400L151 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M251 399L252 400L251 399M390 400L391 401L390 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M154 401L155 402L154 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M248 401L249 402L248 401M153 402L154 403L153 402M155 402L156 403L155 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M249 402L250 403L249 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M253 402L253 438L254 438C254 427.613 257.011 411.56 253 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M389 402L390 403L389 402M154 403L155 404L154 403M247 403L248 404L247 403M248 404L249 405L248 404M388 404L389 405L388 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M155 405L156 406L155 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M157 405L158 406L157 405M246 405L247 406L246 405M156 406L157 407L156 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M158 406L159 407L158 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M247 406L248 407L247 406M387 406L388 407L387 406M157 407L158 408L157 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M244 408L245 409L244 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M160 409L161 410L160 409M245 409L246 410L245 409M386 409L387 410L386 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M161 410L162 411L161 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M243 410L244 411L243 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M386 410L386 413L387 413L386 410M160 411L161 412L160 411M162 411L163 412L162 411M242 411L243 412L242 411M244 411L245 412L244 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M385 411L385 418L421 418L421 417C410.476 417 390.519 421.304 385 411M161 412L162 413L161 412M243 412L244 413L243 412M241 413L242 414L241 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M384 413L385 414L384 413M240 414L241 415L240 414M242 414L243 415L242 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M384 414L373 438C383.329 436.649 393.073 427.876 396 418L385 418L384 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M431 414L431 417L432 417L431 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M241 415L242 416L241 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M383 415L384 416L383 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M239 416L240 417L239 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M387 416L387 417L430 417C418.774 412.29 399.219 416 387 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M167 417L168 418L167 417M238 417L239 418L238 417M382 417L383 418L382 417M168 418L169 419L168 418M239 418L240 419L239 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M381 437L381 438C394.469 438 405.926 440.014 417 432L418 438L422 438L421 418L399.39 418.603L381 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M422 418L423 419L422 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M169 419L170 420L169 419M238 419L239 420L238 419M381 419L382 420L381 419M397 419L398 420L397 419M422 419L422 422L423 422L422 419M395 420L396 421L395 420M235 421L236 422L235 421M380 421L381 422L380 421M396 421L397 422L396 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M234 422L235 423L234 422M236 422L237 423L236 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M394 422L395 423L394 422M421 422L421 425L422 425L421 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M233 423L234 424L233 423M235 423L236 424L235 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M379 423L380 424L379 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M395 423L396 424L395 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M234 424L235 425L234 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M379 424L380 425L379 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M233 425L234 426L233 425M392 425L393 426L392 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M421 425L421 430L422 430L421 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M175 426L176 427L175 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M177 426L178 427L177 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M232 426L233 427L232 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M378 426L379 427L378 426M391 426L392 427L391 426M393 426L394 427L393 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M176 427L177 428L176 427M178 427L179 428L178 427M392 427L393 428L392 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M177 428L178 429L177 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M179 428L180 429L179 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M377 428L378 429L377 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M391 428L392 429L391 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M423 428L423 438L424 438L423 428M178 429L179 430L178 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M229 429L230 430L229 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M226 430L227 431L226 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M228 430L229 431L228 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M376 430L377 431L376 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M181 431L182 432L181 431M183 431L184 432L183 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M225 431L226 432L225 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M227 431L228 432L227 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M386 431L387 432L386 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M388 431L389 432L388 431M182 432L183 433L182 432M184 432L185 433L184 432M224 432L225 433L224 432M226 432L227 433L226 432M375 432L376 433L375 432M385 432L386 433L385 432M387 432L388 433L387 432M415.667 432.333L416.333 432.667L415.667 432.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M183 433L184 434L183 433M186 433L187 434L186 433M225 433L226 434L225 433M386 433L387 434L386 433M417 433L418 434L417 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M185 434L186 435L185 434M187 434L188 435L187 434M374 434L375 435L374 434M382 434L383 435L382 434M413 434L414 435L413 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M415 434L413 438C415.649 437.432 416.355 436.412 415 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M417 434L418 435L417 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M186 435L187 436L186 435M189 435L190 436L189 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M220 435L221 436L220 435M222 435L223 436L222 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M380 435L381 436L380 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M383 435L384 436L383 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M412 435L413 436L412 435M414 435L415 436L414 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M416 435L417 436L416 435M188 436L189 437L188 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M218 436L219 437L218 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M221 436L222 437L221 436M373 436L374 437L373 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M378 436L379 437L378 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M381 436L382 437L381 436M413 436L414 437L413 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M416.333 436.667L416.667 437.333L416.333 436.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M192 437L193 438L192 437M217 437L218 438L217 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M380 437L381 438L380 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M411 437L412 438L411 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M67 438L68 439L67 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M455 438L456 439L455 438M68 439L69 440L68 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M69 439L69 440L454 440L420 439L341 439L69 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M454 439L455 440L454 439M457 439L458 440L457 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbef",
      stroke: "none"
    },
    d: "M67.4336 441.028C62.6426 444.325 63.9457 456.84 70.044 457.852C89.8741 461.142 112.875 458 133 458L366 458L434 458C439.665 458 453.29 460.493 457.258 455.682C461.09 451.036 459.412 441.18 452.985 440.148C429.296 436.344 402.021 440 378 440L150 440L90 440C84.3153 440 72.2413 437.719 67.4336 441.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M456 440L457 441L456 440M458 440L459 441L458 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M457 441L458 442L457 441M459 441L460 442L459 441M65 442L66 443L65 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M459 442L460 443L459 442M63 443L64 444L63 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M458 443L459 444L458 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M64 444L64 454L65 454L64 444M63 454L64 455L63 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M458 454L459 455L458 454M65 455L66 456L65 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M459 455L460 456L459 455M64 456L65 457L64 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M457 456L458 457L457 456M459 456L460 457L459 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M456 457L457 458L456 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M458 457L459 458L458 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M68 458L68 460L70 458L68 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M70 458L70 459L453 459L419 458L341 458L70 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M453.667 458.333L454.333 458.667L453.667 458.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2952c",
      stroke: "none"
    },
    d: "M457 458L458 459L457 458M67 459L68 460L67 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9751fc",
      stroke: "none"
    },
    d: "M455 459L456 460L455 459z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRt2);
export default __webpack_public_path__ + "static/media/rt2.70608f0668aebd5fcad3c5e262de5877.svg";
export { ForwardRef as ReactComponent };